import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getCaseDetailsAction, clearCaseDetailsAction } from 'redux/actions/CaseAction';
import { getClientUserList, listCasesAndLeads } from 'services/CaseServices';
import { createTimeEntry, listTimeEntries, updateTimeEntry, listActivityTypes, getUserHourRate } from 'services/timerServices';
import {
  createExpense,
  getTrustBalanceInfo,
  invoiceExpenses,
  invoiceQuickBooksUpdate,
  invoiceTimeEntry,
  listExpenses,
  updateExpense,
  updateInvoice,
  getInvoice,
  sendInvoiceReport,
  createInvoice,
  getInvoiceNumber,
  getSubscriptionPlan,
} from 'services/billingServices';
import { format } from 'date-fns';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import { listExpenseTypes } from 'redux/actions/ExpenseTypeActions';
import { convertObjectToQuery, fixToTwoDecimal, formatNumbersToCurrencyString, parseRemiderPayload, parseReminderData } from 'utils/utils';
import _ from 'lodash';
import moment from 'moment-timezone';
import { confirmDialog } from 'primereact/confirmdialog';
import { getOfficeLocation } from 'redux/actions/OfficeLocationAction';
import { totalCountEvent } from 'services/generalServices';
import { reduceTax } from 'utils/utility_functions/commonCalculations';
import { getSettleMentDetails } from 'services/expenseService';
import {
  convertToTimezoneFormat,
  convertToTimezoneWithStartOfDayFormat,
  convertToTimezoneWithEndOfDayFormat,
  convertToUserTimezoneDateOnly,
  convertToTimezoneWithEndOfDayTime,
} from 'utils/utility_functions/timezone';
import { UserDetailsContext } from 'context/userDetailsContext';
import { ViewEditInvoice } from '../ViewEditInvoice';
import { InvoicePrintView } from '../InvoicePrintView';
import { convertPaymentStructuresToLowerCase } from './helpers/createInvoiceHelpers';
import { adjustmentItems, adjustmentTypes, appliedToItems, paymentStructure, paymentTerms } from './configs/create_invoice_configs';
import PaymentPlan from './components/PaymentPlan/PaymentPlan';
import InvoiceTotal from './components/InvoiceTotal/InvoiceTotal';
import AvailableTrustFund from './components/AvailableTrustFund/AvailableTrustFund';
import UnPaidInvoice from './components/UnpaidInvoice/UnpaidInvoice';
import { PERSONAL_INJURY } from './constants/createInvoiceConstants';
import BillingDetails from './components/BillingDetails/BillingDetails';
import InvoiceForForm from './components/InvoiceForForm/InvoiceForForm';
import InvoiceDetailsForm from './components/InvoiceDetailsForm/InvoiceDetailsForm';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import debounce from 'lodash.debounce';
import { useForm } from 'react-hook-form';
import { useAccounts } from 'hooks/useAccounts';
import PaymentRequest from './components/PaymentRequest/PaymentRequest';
import { generateFullName } from 'utils/generateFullNameUtils';
import { nofifyTimeManager } from 'redux/actions/TimeEntryUpdateActions';
import GlobalLoader from 'components/GlobalLoader/GlobalLoader';

const CreateInvoice = (props) => {
  const { isLeadSpecific, caseView, selectedInvoice, setShowRecordModal, loadInvoices, filters, getPageLimit } = props || {};

  const dispatch = useDispatch();
  const caseDetailsState = useSelector((state) => state.caseDetails);
  const expense_types = useSelector((state) => state.expenseTypeList.expense_types.expense_type);
  const officeLocationList = useSelector((state) => state.officeLocation.officeLocationList);
  const userContext = useContext(UserDetailsContext);
  const { addToast } = useToast();
  const {
    control,
    getValues,
    watch,
    setValue,
    formState: { isDirty },
  } = useForm();
  const { accountList } = useAccounts();

  /** ========================================  React state starts ===================================== **/

  const [caseList, setCaseList] = useState([]);
  const [selectedCase, setSelectedCase] = useState('');
  const [billingContacts, setBillingContacts] = useState();
  let [selectedBillingContact, setSelectedBillingContact] = useState();
  let [timeEntires, setTimeEntries] = useState([]);
  let [expenses, setExpenses] = useState([]);
  const [timeEntriesTotal, setTimeEntriesTotal] = useState(0);
  const [expenseTotal, setExpenseTotal] = useState(0);
  const [billsAndExpenseTotal, setBillsAndExpenseTotal] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [totalHours, setTotalHours] = useState();
  const [invoiceDate, setInvoiceDate] = useState(new Date());
  const [depositInfo, setDepositInfo] = useState();
  const [dueDate, setDueDate] = useState();
  const [invoiceNumber, setInvoiceNumber] = useState();

  const [taxPercentage, setTaxPercentage] = useState(0);
  const [rateWithTax, setRateWithTax] = useState(0); // time_entries_total + tax

  const [subTotalAmount, setSubTotalAmount] = useState(0.0);

  const [selectedStatus, setSelectedStatus] = useState('Created');
  const [checkDate, setCheckDate] = useState('');
  const [checkNumber, setCheckNumber] = useState('');

  const [selectedPaymentTerm, setSelectedPaymentTerm] = useState();
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [flatFeeTotal, setFlatFeeTotal] = useState(0.0);
  const [flatFeeActualTotal, setFlatFeeActualTotal] = useState(0.0);
  let [adjustments, setAdjustments] = useState([]);
  let [adjustmentTotal, setAdjustmentTotal] = useState(0.0);
  let [discount, setDiscount] = useState(0.0);
  let [flatFeeError, setFlatFeeError] = useState({});
  let [timeEntiresError, setTimeEntriesError] = useState({});
  let [expenseError, setExpenseError] = useState({});
  let [adjustmentError, setAdjustmentError] = useState({});
  const [settlementAmount, setSettlementAmount] = useState(0);
  const [litigation, setLitigation] = useState(false);
  const [contingencyItems, setContingencyItems] = useState();
  const [contingencyTotal, setContingencyTotal] = useState(0);
  const [paymentPlan, setPaymentPlan] = useState(false);
  const [paymentStartDate, setPaymentStartDate] = useState();
  const [firstPaymentAmount, setFirstPaymentAmount] = useState(0);
  let [paymentPlanError, setPaymentPlanError] = useState({});
  const [rate, setRate] = useState();

  const [invoiceDetails, setInvoiceDetails] = useState();
  const [isEdit, setIsEdit] = useState(false);
  const [caseDetails, setCaseDetails] = useState();
  let [teamMembers, setTeamMembers] = useState([]);

  let [flatFees, setFlatFees] = useState([]);
  const [activityTypes, setActivityTypes] = useState();

  const [selectedFrequency, setSelectedFrequency] = useState();
  const [numberOfPayments, setNumberOfPayments] = useState();
  let [paymentDates, setPaymentDates] = useState([]);
  const [subscriptionItems, setSubscriptionItems] = useState([]);
  let [isChanged, setIsChanged] = useState({
    invoice: false,
    time_entries: false,
    expenses: false,
    adjustments: false,
    flat_fees: false,
    payment_plan: false,
    contingency: false,
    retainer: false,
    subscription: false,
  });
  const [trustBalance, setTrustBalance] = useState();
  const [unPaidInvoices, setUnPaidInvoices] = useState([]);
  let [selectedUnpaidInvoices, setSelectedUnpaidInvoices] = useState([]);
  const [trustAccountData, setTrustAccountData] = useState();

  const [forwardedSubtotal, setForwardedSubtotal] = useState(0);
  const [subscriptionTotal, setSubscriptionTotal] = useState(0);
  let [contactDetails, setContactDetails] = useState({});
  const [userHourRate, setUserHourRate] = useState();
  const [showTimeEntry, setShowTimeEntry] = useState(true);
  const [settlementDetails, setSettlementDetails] = useState([]);
  const [searchValue, setSearchValue] = useState();
  const [load, setLoad] = useState();
  const [showAddContactModal, setShowAddContactModal] = useState(false);
  const [showEnableLawftAccessModal, setShowEnableLawftAccessModal] = useState(false);
  const [showEmailRequiredDialogModal, setShowEmailRequiredDialogModal] = useState(false);
  const [enableLawftAccessBillingContact, setEnableLawftAccessBillingContact] = useState();
  const [selectedDate, setSelectedDate] = useState([]);
  const [totalDueAmount, setTotalDueAmount] = useState(0);
  const [forwardedTotalDueAmount, setForwardedTotalDueAmount] = useState(0);
  const [showPR, setShowPR] = useState(false);
  const [paymentRequestData, setPaymentRequestData] = useState({});
  const [allTimeEntriesSaved, setAllTimeEntriesSaved] = useState(true);
  const [allExpensesSaved, setAllExpensesSaved] = useState(true);
  const [createTimeEntryInvoiceClicked, setCreateTimeEntryInvoiceClicked] = useState(false);
  const [createExpenseInvoiceClicked, setCreateExpenseInvoiceClicked] = useState(false);

  const [isContactHasEmail, setIsContactHasEmail] = useState(false);

  //TODO:remove this and add react hook form validation
  let [formErrors, setFormErrors] = useState({
    case: '',
    contact: '',
    invoice_id: '',
    invoice_date: '',
    due_date: '',
    payment_terms: '',
    status: '',
  });

  // Add this state variable with the other state variables (around line 80-90)
  const [billingStatusFilter, setBillingStatusFilter] = useState(''); // "" for All, "billable", "non_billable"

  /** ========================================  React state ends ===================================== **/

  /** ========================================  Other constant conditions starts  ===================================== **/

  const { FLAT_FEE, SUBSCRIPTION, CONTINGENCY_FEE, EVERGREEN_RETAINER, STANDARD_RETAINER } = convertPaymentStructuresToLowerCase() || {};

  const attorneyFeeAmount = settlementDetails?.length > 0 ? settlementDetails[0]?.attorney_fee_amount : 0;

  const isPersonalInjuryPracticeArea = caseDetails?.case_description?.case_practice_area === PERSONAL_INJURY;

  const currentCaseDetails =
    caseDetails && Object.keys(caseDetails).length > 0 && caseDetails.billing_preferences ? caseDetails : caseDetailsState?.caseDetails;

  const lowerCasedPaymentStructure = currentCaseDetails?.billing_preferences?.payment_structure?.toLowerCase() || '';

  const isFlatFee = lowerCasedPaymentStructure === FLAT_FEE;
  const isSubscription = lowerCasedPaymentStructure === SUBSCRIPTION;
  const isContigencyFee = lowerCasedPaymentStructure === CONTINGENCY_FEE;
  const isEverGreenRetainer = lowerCasedPaymentStructure === EVERGREEN_RETAINER;
  const isStandardRetainer = lowerCasedPaymentStructure === STANDARD_RETAINER;

  /** ========================================  Other constant conditions ends  ===================================== **/

  /** ================================= VALIDATION SECTION STARTS ============================= */
  //TODO:REMOVE THIS AND ADD react hook form
  const validateForm = () => {
    let isValid = true;
    if (!selectedCase) {
      formErrors.case = 'Required';
      isValid = false;
    }
    if (!selectedBillingContact) {
      formErrors.contact = 'Required';
      isValid = false;
    }
    if (!invoiceNumber) {
      formErrors.invoice_id = 'Required';
      isValid = false;
    }
    if (!invoiceDate) {
      formErrors.invoice_date = 'Required';
      isValid = false;
    }
    if (!depositInfo && totalAmount - (trustAccountData?.amount_paid || 0) > 0) {
      formErrors.deposit_Info = 'Required';
      isValid = false;
    }

    if (
      !dueDate &&
      !paymentPlan &&
      caseDetails?.billing_preferences?.payment_structure?.toLowerCase() !== paymentStructure.CONTINGENCY_FEE?.toLowerCase()
    ) {
      formErrors.due_date = 'Required';
      isValid = false;
    }
    if (!selectedStatus) {
      formErrors.status = 'Required';
      isValid = false;
    }
    if (
      caseDetails?.billing_preferences?.payment_structure?.toLowerCase() === paymentStructure.CONTINGENCY_FEE?.toLowerCase() &&
      caseDetails?.case_description?._case_practice_area_ === 'Personal Injury'
    ) {
      if (!checkDate) {
        formErrors.check_date = 'Required';
        isValid = false;
      }
      if (!checkNumber) {
        formErrors.check_number = 'Required';
        isValid = false;
      }
      let balance = settlementAmount ?? 0;
      if (caseDetails?.billing_preferences?.is_expense) {
        balance = (settlementAmount ?? 0) - expenseTotal;
      }
      if (balance < 0) {
        isValid = false;
        formErrors.settlement_amount = 'Settlement Amount should be greater than expense';
        setFormErrors({ ...formErrors });
      }
      if (!(settlementAmount > 0)) {
        formErrors.settlement_amount = 'Required';
        isValid = false;
      }
    }
    if (trustAccountData && trustAccountData?.amount_paid) {
      if (trustAccountData.amount_paid > trustAccountData.amount_available) {
        isValid = false;
        formErrors.amount_paid = "Amount paid can't be greater than available balance";
      }
      if (trustAccountData.amount_paid > totalAmount) {
        isValid = false;
        formErrors.amount_paid = "Amount paid can't be greater than invoice amount";
      }
      if (!trustAccountData.credit_account_name) {
        isValid = false;
        formErrors.credit_account_name = 'Required';
      }
      if (trustAccountData?.amount_paid < 0) {
        isValid = false;
        formErrors.amount_paid = 'Invalid Amount';
      }
    }
    if (props.selectedInvoice && props.selectedInvoice?.paid_amount) {
      let paid_amount = props.selectedInvoice?.paid_amount;
      paid_amount = parseFloat(paid_amount);
      if (totalAmount < paid_amount) {
        isValid = false;
        formErrors.total_amount = "Total amount can't be lesser than paid amount";
      }
    }
    if (showPR && !paymentRequestData?.amount) {
      formErrors.pr_amount = 'Required';
      isValid = false;
    }
    if (showPR && !paymentRequestData?.dueDate) {
      formErrors.pr_due_date = 'Required';
      isValid = false;
    }
    if (showPR && !paymentRequestData?.depositInfo) {
      formErrors.pr_deposit_Info = 'Required';
      isValid = false;
    }

    setFormErrors({ ...formErrors });
    if (!isValid || allTimeEntriesSaved === false || allExpensesSaved === false) {
      if (!isValid) {
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.FORM_DATA_MISSING);
      } else if (allTimeEntriesSaved === false) {
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.ALL_TIME_ENTRIES_NOT_SAVED);
      } else if (allExpensesSaved === false) {
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.ALL_EXPENSES_NOT_SAVED);
      }
    }
    return isValid;
  };

  const validatePaymentPlan = (showToast = true) => {
    let total = 0;
    let isValid = true;
    if (paymentPlan) {
      if (paymentDates && paymentDates.length > 0) {
        paymentDates.forEach((index, id) => {
          let amount = index.amount ? parseFloat(index.amount) : 0;
          if (!index.date) {
            paymentPlanError[`${id}_date`] = 'Required';
            isValid = false;
          }
          if (!amount || amount <= 0) {
            paymentPlanError[`${id}_amount`] = 'Required';
            isValid = false;
          } else {
            total = total + amount;
          }
        });
        if (Math.round(total, 2) !== Math.round(parseFloat(totalAmount), 2)) {
          paymentPlanError['total'] = 'Payment plan total is not equal to the invoice total';
          isValid = false;
        }
      }
      if (paymentPlan && (!paymentDates || paymentDates.length === 0) && numberOfPayments && numberOfPayments > 1) {
        paymentPlanError['payment_plan'] = 'Required payment plan';
        isValid = false;
      }
      if (!paymentStartDate && paymentPlan) {
        paymentPlanError['start_date'] = 'Required';
        isValid = false;
      }
      if (paymentPlan && firstPaymentAmount !== 0 && !firstPaymentAmount) {
        paymentPlanError['first_amount'] = 'Required';
        isValid = false;
      }

      if (
        (!paymentDates || (paymentDates && paymentDates.length === 0)) &&
        firstPaymentAmount !== rate &&
        paymentPlan &&
        numberOfPayments === '1'
      ) {
        paymentPlanError['first_amount'] = 'Amount is not equal to fee';
        isValid = false;
      }

      setPaymentPlanError({ ...paymentPlanError });
    }

    if (!isValid && showToast) {
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.FORM_DATA_MISSING);
    }

    return isValid;
  };

  const validateTables = () => {
    let isValid = true;
    if (parseFloat(caseDetailsState?.caseDetails?.billing_preferences?.due) !== 0 || invoiceDetails?.flat_fees) {
      if (flatFees && flatFees.length > 0) {
        flatFees.forEach((index, id) => {
          if (!index.flat_fee_date) {
            flatFeeError[`${id}_date`] = 'Required';
            isValid = false;
          }
          if (!index.flat_fee_amount || index.flat_fee_amount <= 0) {
            flatFeeError[`${id}_amount`] = 'Required';
            isValid = false;
          }
        });
        setFlatFeeError({ ...flatFeeError });
      }
    }
    if (
      timeEntires &&
      timeEntires.length > 0 &&
      ![paymentStructure.SUBSCRIPTION?.toLowerCase()].includes(caseDetails?.billing_preferences?.payment_structure?.toLowerCase()) &&
      showTimeEntry
    ) {
    }
    if (adjustments && adjustments.length > 0) {
      adjustments.forEach((index, id) => {
        if (!index.adjustment_item_id) {
          adjustmentError[`${id}_item`] = 'Required';
          isValid = false;
        }
        if (!index.adjustment_to_id) {
          adjustmentError[`${id}_applied_to`] = 'Required';
          isValid = false;
        }
        if (!index.adjustment_type_id) {
          adjustmentError[`${id}_type`] = 'Required';
          isValid = false;
        }
        if (index.adjustment_type_id === 1 && (!index.percentage || index.percentage <= 0)) {
          adjustmentError[`${id}_percentage`] = 'Required';
          isValid = false;
        }
        if (!index.amount || index.amount <= 0) {
          adjustmentError[`${id}_amount`] = 'Required';
          isValid = false;
        }
        if (index.amount && index.basic_amount && +index.amount > +index.basic_amount) {
          adjustmentError[`${id}_amount`] = 'Amount higher than basic amount';
          isValid = false;
        }
      });
      setAdjustmentError({ ...adjustmentError });
    }

    if (!isValid) {
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.FORM_DATA_MISSING);
    }
    return isValid;
  };

  const resetFormErrors = (field) => {
    if (field && field === 'all') {
      setFormErrors({
        payee: '',
        payment_structure: '',
        rate: '',
        payment_number: '',
        payment_frequency: '',
        contingency_percentage: '',
        retainer_amount: '',
      });
    } else if (field) {
      formErrors[field] = '';
      setFormErrors({ ...formErrors });
    }
  };

  /** ================================ VALIDATION SECTION ENDS ============================= */

  const loadTimeEntries = (data, limit) => {
    const is_full_list = isLeadSpecific ? false : true;
    listTimeEntries(data, false, limit, '', '', is_full_list).then((timeEntiresResponse) => {
      if (timeEntiresResponse?.data?.time_entries) {
        if (timeEntiresResponse?.data?.time_entries.length > 0) {
          timeEntiresResponse?.data?.time_entries.forEach((index) => {
            if (!index.team_member_name) {
              let name = '';
              if (index?.created_by_details?.first_name) name += index?.created_by_details?.first_name;
              if (index?.created_by_details?.last_name) name = name + ' ' + index?.created_by_details?.last_name;

              index.team_member_name = name;
              index.team_member_id = index?.created_by_details?.user_id;
            }
          });
        }

        setTimeEntries([...timeEntiresResponse.data.time_entries, ...timeEntires?.filter((data) => data.is_added_entry === true)]);
      }
    });
  };

  //TODO:Check this logic
  const onChangeCase = async (e) => {
    setSelectedCase(e.value);
    setSelectedBillingContact();
    setPaymentPlan(false);

    setPaymentDates([]);
    if (!props.selectedInvoice) {
      setDueDate();
      setSelectedPaymentTerm();
      setValue('reminder', []);
      setValue('is_client_contact', false);
      setValue('is_billing_contact', false);
      setExpenseTotal(0);
      setTotalHours(0);
      setTimeEntriesTotal(0);
      setTotalAmount(0);

      setSubTotalAmount(0);
      setTimeEntries(timeEntires.filter((v) => v.is_added_entry));
      setTimeEntriesError({});
      setExpenses([]);
      setFlatFees([]);
      setAdjustments([]);
      setFlatFeeTotal(0);
      setAdjustmentTotal(0);
      setDiscount(0);

      setSelectedFrequency();
      setNumberOfPayments();
      setPaymentStartDate();
      setRate();
      setTotalAmount(0);

      setContingencyItems();
      setContingencyTotal(0);
      setSubscriptionTotal(0);
      setForwardedSubtotal(0);
      setUnPaidInvoices([]);
      setSelectedUnpaidInvoices([]);
      setTrustAccountData();
      setTrustBalance();
      setFormErrors({
        case: '',
        contact: '',
        invoice_id: '',
        invoice_date: '',
        due_date: '',
        payment_terms: '',
        status: '',
      });
    }

    if (e?.value?.id) {
      try {
        setLoading(true);
        dispatch(getCaseDetailsAction('', '', '', e?.value?.id));
        let user_list = [];
        getClientUserList(e?.value?.id, false, false, true, false, props.isLeadSpecific ? true : false, false, false).then((response) => {
          if (response?.data && response.data.length > 0) {
            response.data.forEach((index) => {
              let name = index.first_name ? index.first_name : '';
              if (index.last_name) name = name + ' ' + index.last_name;
              let obj = {
                name: name,
                ...index,
              };
              user_list.push(obj);
            });

            // Sort the user list alphabetically by first_name
            user_list.sort((a, b) => {
              const nameA = (a?.name || '').toLowerCase();
              const nameB = (b?.name || '').toLowerCase();
              return nameA.localeCompare(nameB);
            });

            setBillingContacts([...user_list]);

            if (props.selectedInvoice) {
              let contact_id = user_list.filter((index) => index?.contact_id === invoiceDetails?.invoice?.contact_id);
              if (contact_id.length > 0) setSelectedBillingContact(contact_id[0]);
            }
          }
        });
        let data = {
          case_id: e?.value?.id,
          time_entry_date: '',
          ...pickExtractedDate(selectedDate),
          time_entry_status: 'OPEN',
          search_key: '',
          billing_status: 'billable',
        };

        if (!props.selectedInvoice) {
          if (selectedDate.length !== 0) {
            let response = await totalCountEvent('time_entries', e?.value?.id);
            let limit = response?.data > 0 ? response?.data : 0;
            loadTimeEntries(data, limit);
          }

          let expenseFilter = {
            case_id: e?.value?.id,
            expense_status: 'UNINVOICED',
            expense_from: '',
            expense_to: '',
            expense_date: '',
            expense_filter: '',
            search_key: '',
          };
          let response = await totalCountEvent('expense', e?.value?.id);
          let limit = response?.data > 0 ? response?.data : 0;
          listExpenses(expenseFilter, limit).then((expenseResponse) => {
            if (expenseResponse?.data?.expenses) {
              setExpenses([...expenseResponse?.data?.expenses]);
            }
          });
        }

        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    }
  };

  const onChangeContact = (e) => {
    setEnableLawftAccessBillingContact(e?.value);
    setIsChanged((preVal) => ({ ...preVal, invoice: true }));
    // if (e?.value?.is_create_client_portal === false || !Boolean(e?.value?.email)) {
    //   // If client portal is not created, enable Lawft access
    //   setShowEnableLawftAccessModal(true);
    // }

    Boolean(e?.value?.email) ? setIsContactHasEmail(true) : setIsContactHasEmail(false);
    // setShowEmailRequiredDialogModal(true);

    // } else {
    setSelectedBillingContact({ ...e.value });

    contactDetails = {};
    contactDetails.city = e?.value?.city;
    contactDetails.street = e?.value?.street;
    contactDetails.state = e?.value?.state;
    contactDetails.country = e?.value?.country;
    contactDetails.zip = e?.value?.zip;
    contactDetails.phone = e?.value?.phone;
    contactDetails.country_code = e?.value?.country_code;
    setContactDetails({ ...contactDetails });
    formErrors.contact = '';
    setFormErrors({ ...formErrors });
    // }
  };

  const onSubmit = (send = false) => {
    setCreateTimeEntryInvoiceClicked(true);
    setCreateExpenseInvoiceClicked(true);
    if (validateForm() && validateTables() && validatePaymentPlan() && allTimeEntriesSaved && allExpensesSaved) {
      const selectedReminder = getValues();
      let contact_name = '';
      const selectedAccount = accountList?.find((v) => v?.account_id === depositInfo);
      contact_name = selectedBillingContact?.first_name;
      if (selectedBillingContact?.middle_name) contact_name = contact_name + ' ' + selectedBillingContact?.middle_name;
      if (selectedBillingContact?.last_name) contact_name = contact_name + ' ' + selectedBillingContact?.last_name;
      let address = {};
      if (officeLocationList && officeLocationList.length > 0) {
        officeLocationList.map((index) => {
          if (index.is_primary_office === 'true') {
            address = index;
          }
        });
      }
      let case_id = props.isLeadSpecific ? props?.caseDetails?.case_id : selectedCase?.id;
      let case_name = props?.isLeadSpecific
        ? props?.caseDetails?.case_description?.case_name
        : selectedCase?.case_description?.case_name
        ? selectedCase?.case_description?.case_name
        : selectedCase?.value;
      let time_entries = [];
      let expenses_list = [];
      let flat_fees = [];
      let adjustments_list = [];

      if (timeEntires && timeEntires.length > 0) {
        time_entries = timeEntires.map((data) => {
          return {
            ...data,
            total_hours: data?.total_hours ? data.total_hours.toString() : '0',
            hour_rate: data?.hour_rate ? data.hour_rate.toString() : '0',
            case_id: case_id,
            case_name: case_name,
            amount: (data?.hour_rate * data?.total_hours).toString() || '0',
          };
        });
        time_entries = time_entries.map(({ is_added_entry, ...rest }) => ({
          ...rest,
        }));
      }

      if (expenses && expenses.length > 0) {
        expenses_list = expenses.map((data) => {
          return {
            ...data,
            case_id: case_id,
            case_name: case_name,
            quantity: data?.quantity ? data.quantity.toString() : '0',
            rate_per_unit: data?.rate_per_unit ? data.rate_per_unit.toString() : '0',
            total_amount: data?.total_amount ? data.total_amount.toString() : '0',
          };
        });
      }

      if (flatFees && flatFees.length > 0) {
        flat_fees = flatFees.map((data) => {
          return {
            ...data,
            flat_fee_amount: data.flat_fee_amount.toString(),
            case_id: case_id,
            case_name: case_name,
            unique_number: props?.caseDetails?.unique_number,
          };
        });
      }

      if (adjustments && adjustments.length > 0) {
        adjustments_list = adjustments.map((item) => {
          return {
            ...item,
            case_id: case_id,
            case_name: case_name,
            adjustment_item_id: item?.adjustment_item_id ? item.adjustment_item_id.toString() : '0',
            adjustment_to_id: item?.adjustment_to_id ? item.adjustment_to_id.toString() : '0',
            adjustment_type_id: item?.adjustment_type_id ? item.adjustment_type_id.toString() : '0',
            amount: item?.amount ? item.amount.toString() : '0',
            basic_amount: item?.basic_amount ? item.basic_amount.toString() : '0',
          };
        });
      }
      let invoice_assignee = [];
      if (selectedReminder?.is_billing_contact) {
        invoice_assignee.push('billing_contact');
      }
      if (selectedReminder?.is_client_contact) {
        invoice_assignee.push('main_client');
      }

      let data = {
        invoice: {
          is_lead: isLeadSpecific,
          // case_id: selectedCase?.case_id,
          // case_name: selectedCase?.case_description?.case_name,
          case_id: props?.caseDetails?.case_id ? props?.caseDetails?.case_id : selectedCase?.id,
          case_name: props?.caseDetails?.case_description?.case_name
            ? props?.caseDetails?.case_description?.case_name
            : selectedCase?.value
            ? selectedCase?.value
            : selectedCase?.case_description?.case_name,
          contact_id: selectedBillingContact?.contact_id,
          contact_name: contact_name,
          street: contactDetails?.street,
          city: contactDetails?.city,
          state: contactDetails?.state,
          zip_code: contactDetails?.zip,
          country: contactDetails?.country,
          phone: contactDetails?.phone,
          country_code: contactDetails?.country_code,
          trust_balance_details: trustBalance ? trustBalance : {},
          invoice_date: invoiceDate
            ? moment(convertToTimezoneWithStartOfDayFormat(invoiceDate, userContext?.userDetails?.timezone)).format()
            : '',
          payment_term_id: paymentTerms.findIndex((index) => index.label === selectedPaymentTerm) + 1,
          payment_terms: selectedPaymentTerm || '',
          due_date: dueDate || '',
          is_reminder: selectedReminder?.reminder?.length > 0,
          reminder: parseRemiderPayload(selectedReminder?.reminder),
          invoice_assignee: invoice_assignee,
          is_reminder_changed: isDirty,
          // invoice_status: selectedStatus,
          invoice_status: invoiceDetails ? _.startCase(_.toLower(invoiceDetails.invoice_status)) : 'Created',
          invoice_number: invoiceNumber,
          check_date: checkDate,
          check_number: checkNumber,
          time_entry_preferences: {
            billing_status_filter: billingStatusFilter,
            date_range: selectedDate
              ? {
                  from: selectedDate[0] ? moment(selectedDate[0]).format() : null,
                  to: selectedDate[1] ? moment(selectedDate[1]).format() : selectedDate[0] ? moment(selectedDate[0]).format() : null,
                }
              : null,
          },
        },
        time_entries: {
          total_hours: totalHours ? totalHours.toString() : '0',
          total_amount: timeEntriesTotal ? timeEntriesTotal.toString() : '0',
          // time_entry_data: time_entries,
        },
        expenses: {
          // expense_data: expenses_list,
          total_amount: expenseTotal ? expenseTotal.toString() : '0',
        },
        adjustments: {
          adjustment_data: adjustments_list,
          discount_amount: discount.toString(),
          addition_amount: adjustmentTotal.toString(),
        },
        billed_from: {
          address: address,
        },
        deposit_account_id: selectedAccount?.account_id,
        deposit_account_name: selectedAccount?.account_name,
        deposit_account_type: selectedAccount?.account_type,
        total_amount: totalAmount.toString(),
      };

      if (
        caseDetails?.billing_preferences?.payment_structure?.toLowerCase() === paymentStructure.CONTINGENCY_FEE?.toLowerCase() &&
        caseDetails?.case_description?._case_practice_area_ === 'Personal Injury'
      ) {
        data.settlement = {
          balance_owed: settlementDetails[0]?.balance_owed ?? 0,
          check_to_client: totalAmount ?? 0,
          attorney_fee_amount: settlementDetails[0]?.attorney_fee_amount ?? 0,
          total_case_expense: settlementDetails[0]?.total_case_expense ?? 0,
        };
        data.expenses.total_case_expense = settlementDetails[0]?.total_case_expense ?? 0;
        data.medical_bills = settlementDetails[0]?.medical_expense_per_provider ?? 0;
        data.case_expenses = settlementDetails[0]?.case_expense_per_vendor ?? 0;
      }

      if (props.selectedInvoice) {
        data.invoice.is_changed = isChanged.invoice || isDirty;
        data.time_entries.is_changed = isChanged.time_entries;
        data.expenses.is_changed = isChanged.expenses;
        data.adjustments.is_changed = isChanged.adjustments;
      }

      if (
        caseDetailsState.caseDetails?.billing_preferences?.payment_structure?.toLowerCase() === paymentStructure.FLAT_FEE?.toLowerCase() &&
        (parseFloat(caseDetailsState?.caseDetails?.billing_preferences?.due) !== 0 || invoiceDetails?.flat_fees || flat_fees)
      ) {
        let flat_fees_temp = flat_fees.map((object) => {
          delete object?.actual_amount;
          return object;
        });
        data.flat_fees = {
          flat_fee_data: flat_fees_temp,
          total_amount: flatFeeTotal.toString(),
          case_sk: caseDetailsState?.caseDetails?.sk,
          case_pk: caseDetailsState?.caseDetails?.pk,
        };
        if (caseDetailsState?.caseDetails?.billing_preferences?.tax_percentage) {
          data.flat_fees.tax_percentage = caseDetailsState?.caseDetails?.billing_preferences?.tax_percentage;
        }
        if (caseDetailsState?.caseDetails?.billing_preferences?.amount_with_tax) {
          data.flat_fees.default_flat_fee = caseDetailsState?.caseDetails?.billing_preferences?.amount_with_tax.toString();
        } else {
          data.flat_fees.default_flat_fee = caseDetailsState?.caseDetails?.billing_preferences?.rate.toString();
        }
        if (props.selectedInvoice) {
          data.flat_fees.is_changed = isChanged.flat_fees;
          data.flat_fees.total_amount_old = invoiceDetails?.flat_fees?.total_amount;
        }
      }

      if (!showTimeEntry) {
        data.time_entries = {};
      }

      data.is_payment_plan = paymentPlan;
      let paymentDatesTemp = [];
      if (paymentDates?.length) {
        //to make sure the amount is converted to string to prevent the BE from breaking.
        paymentDatesTemp = paymentDates.map((data) => {
          return {
            ...data,
            amount: data?.amount ? data.amount.toString() : '0',
            date: convertToTimezoneWithEndOfDayFormat(data.date, userContext?.userDetails?.timezone),
          };
        });
      }
      if (paymentPlan) {
        data.payment_plan = {
          payment_starting_date: convertToTimezoneWithEndOfDayFormat(paymentStartDate, userContext?.userDetails?.timezone),
          first_payment_amount: firstPaymentAmount ? firstPaymentAmount.toString() : '0',
          payment_plan_data: paymentDatesTemp,
          frequency_of_payment: selectedFrequency,
          number_of_payments: numberOfPayments,
          total_amount: totalAmount.toString(),
        };
        data.invoice.due_date = data.payment_plan.payment_plan_data[paymentDatesTemp.length - 1].date;
        if (props.selectedInvoice) data.payment_plan.is_changed = isChanged.payment_plan;
      }
      if (
        caseDetailsState.caseDetails?.billing_preferences?.payment_structure?.toLowerCase() ===
        paymentStructure.CONTINGENCY_FEE?.toLowerCase()
      ) {
        data.contingency = {
          settled_amount: settlementAmount,
          total_amount: contingencyTotal,
          is_expense_included: caseDetailsState.caseDetails?.billing_preferences?.is_expense,
          rate: caseDetailsState.caseDetails?.billing_preferences?.rate,
          is_litigation: litigation,
          contingency_data: contingencyItems,
        };
        if (props.selectedInvoice) data.contingency.is_changed = isChanged.contingency;
      }
      if (
        caseDetailsState.caseDetails?.billing_preferences?.payment_structure?.toLowerCase() ===
          paymentStructure.EVERGREEN_RETAINER?.toLowerCase() ||
        caseDetailsState.caseDetails?.billing_preferences?.payment_structure?.toLowerCase() ===
          paymentStructure.STANDARD_RETAINER?.toLowerCase()
      ) {
        data.retainer = {
          retainer_amount: caseDetails?.billing_preferences?.retainer_amount,
          retainer_date: caseDetails?.billing_preferences?.retainer_date,
        };

        const dueValue = currentCaseDetails?.billing_preferences?.due;
        const hasNoDue = dueValue === null || dueValue === undefined;
        const isRetainerCase =
          caseDetailsState.caseDetails?.billing_preferences?.payment_structure?.toLowerCase() ===
            paymentStructure.STANDARD_RETAINER?.toLowerCase() ||
          caseDetailsState.caseDetails?.billing_preferences?.payment_structure?.toLowerCase() ===
            paymentStructure.EVERGREEN_RETAINER?.toLowerCase();

        const shouldShowFlatFees =
          isRetainerCase && ((!props.selectedInvoice && hasNoDue) || (props.selectedInvoice && invoiceDetails?.flat_fees));

        if (shouldShowFlatFees) {
          if (invoiceDetails?.flat_fees) {
            let flat_fee_data_arr = [];
            if (Array.isArray(invoiceDetails.flat_fees.flat_fee_data)) {
              flat_fee_data_arr = invoiceDetails.flat_fees.flat_fee_data;
            } else if (
              typeof invoiceDetails.flat_fees.flat_fee_data === 'object' &&
              invoiceDetails.flat_fees.flat_fee_data !== null &&
              !Array.isArray(invoiceDetails.flat_fees.flat_fee_data)
            ) {
              flat_fee_data_arr = [invoiceDetails.flat_fees.flat_fee_data];
            }

            data.flat_fees = {
              ...invoiceDetails.flat_fees,
              flat_fee_data: flat_fee_data_arr,
            };

            if (props.selectedInvoice) {
              data.flat_fees.is_changed = isChanged.payment_plan;
              data.flat_fees.total_amount_old = invoiceDetails?.total_amount || invoiceDetails?.flat_fees?.total_amount;
            }
          } else {
            let name = caseDetailsState.caseDetails?.created_by_details?.first_name;
            name = name + ' ' + caseDetailsState.caseDetails?.created_by_details?.last_name;
            let retainer_fee_amount = caseDetails?.billing_preferences?.retainer_amount;

            let obj = {
              actual_amount: caseDetailsState?.caseDetails?.billing_preferences?.retainer_amount,
              flat_fee_date: caseDetails?.billing_preferences?.retainer_date ? caseDetails?.billing_preferences?.retainer_date : new Date(),
              flat_fee_amount: retainer_fee_amount || 0.0,
              employee_name: name,
              employee_id: caseDetailsState.caseDetails?.created_by_details?.user_id,
              billable: true,
              item_name: caseDetailsState?.caseDetails?.billing_preferences?.payment_structure || '',
              tax_applied: false,
            };

            data.flat_fees = {
              flat_fee_data: [obj],
              total_amount: totalAmount?.toString() || '0.0',
              case_sk: caseDetailsState?.caseDetails?.sk,
              case_pk: caseDetailsState?.caseDetails?.pk,
              tax_percentage: 0.0,
              default_flat_fee: caseDetailsState?.caseDetails?.billing_preferences?.retainer_amount?.toString() || '',
            };
            if (props.selectedInvoice) {
              data.flat_fees.is_changed = isChanged.payment_plan;
              data.flat_fees.total_amount_old = invoiceDetails?.total_amount;
            }
          }
        }
        if (caseDetailsState?.caseDetails?.billing_preferences?.tax_percentage) {
          data.time_entries.tax_percentage = taxPercentage;
          data.time_entries.total_amount_with_tax = rateWithTax ? rateWithTax.toString() : '0';
        }
        if (props.selectedInvoice) data.retainer.is_changed = isChanged.retainer;
      }
      if (
        caseDetailsState?.caseDetails?.billing_preferences?.payment_structure?.toLowerCase() ===
        paymentStructure.SUBSCRIPTION?.toLowerCase()
      ) {
        data.subscription = {
          total_amount: totalAmount.toString(),
          subscription_data: {
            ...subscriptionItems,
            unique_number: props?.caseDetails?.unique_number,
          },
        };
        if (caseDetailsState?.caseDetails?.billing_preferences?.tax_percentage) {
          data.subscription.tax_percentage = taxPercentage;
        }
        if (data?.subscription?.subscription_data?.amount_with_tax) {
          //to make sure only string is send to the server.
          data.subscription.subscription_data.amount_with_tax = (data?.subscription?.subscription_data?.amount_with_tax).toString();
        }
        if (data?.subscription?.subscription_data?.rate) {
          //to make sure only string is send to the server.
          data.subscription.subscription_data.rate = (data?.subscription?.subscription_data?.rate).toString();
        }
        if (props.selectedInvoice) data.subscription.is_changed = isChanged.subscription;
        data.time_entries.time_entry_data = [];
        data.time_entries.total_amount = '0';
        data.time_entries.total_hours = '0.00';
      }
      data.payment_structure = caseDetailsState?.caseDetails?.billing_preferences?.payment_structure;
      setLoading(true);

      if (trustAccountData?.amount_paid) {
        data.is_trust_account = true;
        data.trust_account_data = trustAccountData;
      }
      if (selectedUnpaidInvoices && selectedUnpaidInvoices.length > 0) {
        data.unpaid_invoices = {
          unpaid_invoice_data: selectedUnpaidInvoices,
          total_amount: forwardedTotalDueAmount.toString(),
        };
      }

      if (props.selectedInvoice) {
        let updatedData = {
          ...props.selectedInvoice,
          ...data,
          created_by_details: invoiceDetails.created_by_details,
          invoice_status: _.startCase(_.toLower(invoiceDetails.invoice_status)),
        };

        updateInvoice(updatedData, isLeadSpecific ? isLeadSpecific : selectedCase?.is_lead)
          .then((response) => {
            const invoiceId = selectedInvoice?.invoice_id;
            const pk = selectedInvoice?.pk;
            const sk = selectedInvoice?.sk;
            const case_id = selectedCase?.id;
            const is_trust_account = invoiceDetails?.is_trust_account;
            const mode_of_operation = 'updating invoice';

            const timeEntryPayload = {
              time_entry_data: (timeEntires || [])
                .filter((entry) => {
                  const original = invoiceDetails?.time_entries?.time_entry_data?.find(
                    (originalEntry) => originalEntry.pk === entry.pk && originalEntry.sk === entry.sk
                  );
                  const billableChanged = original ? original.billable !== entry.billable : true;
                  return entry?.pk && entry?.sk && (!entry?.invoice_ref || billableChanged);
                })
                .map((entry) => ({
                  pk: entry?.pk,
                  sk: entry?.sk,
                  billable: entry?.billable,
                })),
            };

            const expensesPayload = {
              expense_data: (expenses_list || [])
                .filter((entry) => {
                  const original = invoiceDetails?.expenses?.expense_data?.find((e) => e.pk === entry.pk && e.sk === entry.sk);
                  const billableChanged = original ? original.billable !== entry.billable : true;
                  return entry?.pk && entry?.sk && (!entry?.invoice_ref || billableChanged);
                })
                .map((entry) => ({
                  pk: entry.pk,
                  sk: entry.sk,
                  billable: entry?.billable,
                })),
            };

            const promises = [];

            if (timeEntryPayload?.time_entry_data?.length > 0 && invoiceId) {
              promises.push(invoiceTimeEntry(invoiceId, timeEntryPayload, case_id, case_name));
            }

            if (expensesPayload?.expense_data?.length > 0 && invoiceId) {
              promises.push(invoiceExpenses(invoiceId, expensesPayload, case_id, case_name));
            }

            Promise.all(promises)
              .then(() => {
                console.log('Linked entries to invoice successfully.');
              })
              .catch((err) => {
                console.error('Error linking entries:', err);
              })
              .finally(() => {
                if (userContext?.userDetails?.is_quickbook_connected) {
                  invoiceQuickBooksUpdate(pk, sk, case_id, is_trust_account ? is_trust_account : false, mode_of_operation)
                    .then(() => {
                      console.log('QuickBooks sync completed.');
                    })
                    .catch((err) => {
                      console.error(err);
                    });
                }
              });

            setLoading(false);
            addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.INVOICE_UPDATE_SUCCESS);
            props.onSuccess();
          })
          .catch((err) => {
            let msg = toastConstant.message.INVOICE_UPDATE_FAILED;
            if (err && err?.response?.data?.message) {
              msg = err.response.data.message;
            }
            setLoading(false);
            addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, msg);
          });
      } else {
        if (showPR) {
          const selectedAccount = accountList?.find((v) => v?.account_id === paymentRequestData?.depositInfo);
          data.payment_request_data = {
            case_id: props?.caseDetails?.case_id ? props?.caseDetails?.case_id : selectedCase?.id,
            case_name: props?.caseDetails?.case_description?.case_name
              ? props?.caseDetails?.case_description?.case_name
              : selectedCase?.value,
            amount: paymentRequestData?.amount,
            due_date: paymentRequestData?.dueDate,
            billing_contact_id: selectedBillingContact?.contact_id,
            billing_contact_name: generateFullName(selectedBillingContact),
            deposit_into: selectedAccount?.account_type,
            deposit_account_type: selectedAccount?.account_type,
            deposit_account_name: selectedAccount?.account_name,
            deposit_account_id: selectedAccount?.account_id,
          };
        }
        createInvoice(data, props.isLeadSpecific ? props?.isLeadSpecific : selectedCase?.is_lead)
          .then((response) => {
            setLoading(false);
            addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.INVOICE_CREATE_SUCCESS);

            const invoiceId = response?.data?.invoice_id;
            const pk = response?.data?.pk;
            const sk = response?.data?.sk;
            const case_id = selectedCase?.id;
            const is_trust_account = data?.is_trust_account;
            const mode_of_operation = 'creating invoice';

            const timeEntryPayload = {
              time_entry_data: (timeEntires || [])
                .filter((entry) => {
                  const original = invoiceDetails?.time_entries?.time_entry_data?.find(
                    (originalEntry) => originalEntry.pk === entry.pk && originalEntry.sk === entry.sk
                  );
                  const billableChanged = original ? original.billable !== entry.billable : true;
                  return entry?.pk && entry?.sk && (!entry?.invoice_ref || billableChanged);
                })
                .map((entry) => ({
                  pk: entry?.pk,
                  sk: entry?.sk,
                  billable: entry?.billable,
                })),
            };

            const expensesPayload = {
              expense_data: (expenses_list || [])
                .filter((entry) => {
                  const original = invoiceDetails?.expenses?.expense_data?.find((e) => e.pk === entry.pk && e.sk === entry.sk);
                  const billableChanged = original ? original.billable !== entry.billable : true;
                  return entry?.pk && entry?.sk && (!entry?.invoice_ref || billableChanged);
                })
                .map((entry) => ({
                  pk: entry.pk,
                  sk: entry.sk,
                  billable: entry?.billable,
                })),
            };

            const promises = [];

            if (timeEntryPayload?.time_entry_data?.length > 0 && invoiceId) {
              promises.push(invoiceTimeEntry(invoiceId, timeEntryPayload, case_id, case_name));
            }

            if (expensesPayload?.expense_data?.length > 0 && invoiceId) {
              promises.push(invoiceExpenses(invoiceId, expensesPayload, case_id, case_name));
            }

            Promise.all(promises)
              .then(() => {
                console.log('Linked entries to invoice successfully.');
              })
              .catch((err) => {
                console.error('Error linking entries:', err);
              })
              .finally(() => {
                if (userContext?.userDetails?.is_quickbook_connected) {
                  invoiceQuickBooksUpdate(pk, sk, case_id, is_trust_account ? is_trust_account : false, mode_of_operation)
                    .then(() => {
                      console.log('QuickBooks sync completed.');
                    })
                    .catch((err) => {
                      console.error(err);
                    });
                }
              });
            if (send) {
              sendInvoice(response?.data);
            }
            setTimeout(() => {
              props.onSuccess();
            }, 100);
          })
          .catch((err) => {
            let msg = toastConstant.message.INVOICE_CREATE_FAILED;
            if (err && err?.response?.data?.message) {
              msg = err.response.data.message;
            }
            setLoading(false);
            addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, msg);
          });
      }
    }
  };

  const nextDate = (frequency, date) => {
    let now = '';
    switch (frequency) {
      case 'weekly':
        return new Date(date.setDate(date.getDate() + 7));
      case 'biweekly':
        return new Date(date.setDate(date.getDate() + 14));
      case 'monthly':
        return new Date(date.setMonth(date.getMonth() + 1));

      case 'quarterly':
        return new Date(date.setMonth(date.getMonth() + 3));

      case 'yearly':
        return new Date(date.setFullYear(date.getFullYear() + 1));

      default:
        return new Date();
    }
  };

  const addFlatFee = () => {
    if (caseDetailsState.caseDetails?.billing_preferences?.payment_structure?.toLowerCase() === paymentStructure.FLAT_FEE?.toLowerCase()) {
      let _flatFees = flatFees;
      let name = caseDetailsState.caseDetails?.created_by_details?.first_name;
      name = name + ' ' + caseDetailsState.caseDetails?.created_by_details?.last_name;
      let flat_fee_amount = '';
      let due = caseDetailsState?.caseDetails?.billing_preferences?.due;

      if (caseDetailsState?.caseDetails?.billing_preferences?.due) {
        due = parseFloat(due);
        flat_fee_amount = due;
      } else {
        if (caseDetailsState?.caseDetails?.billing_preferences?.amount_with_tax) {
          flat_fee_amount = caseDetailsState?.caseDetails?.billing_preferences?.amount_with_tax.toString();
        } else {
          flat_fee_amount = caseDetailsState?.caseDetails?.billing_preferences?.rate.toString();
        }
      }
      if (flat_fee_amount === '0') flat_fee_amount = '';
      let obj = {
        flat_fee_date: new Date(),
        flat_fee_amount: flat_fee_amount.toString(),
        actual_amount: flat_fee_amount.toString(),
        employee_name: name,
        employee_id: caseDetailsState.caseDetails?.created_by_details?.user_id,
        billable: true,
        item_name: paymentStructure.FLAT_FEE,
      };
      if (caseDetailsState?.caseDetails?.billing_preferences?.tax_percentage) {
        obj.actual_amount = reduceTax(flat_fee_amount, caseDetailsState?.caseDetails?.billing_preferences?.tax_percentage);
      }
      if (props.selectedInvoice) obj.is_new = true;
      _flatFees.push(obj);
      setFlatFees([..._flatFees]);
      isChanged.flat_fees = true;
      setIsChanged({ ...isChanged });
    }
  };

  const addTimeEntry = () => {
    let _timeEntries = timeEntires;
    let obj = { billable: true };
    if (userHourRate) obj.hour_rate = userHourRate;
    if (!userHourRate && timeEntires && timeEntires.length > 0) {
      try {
        let lastIndex = timeEntires.length - 1;
        let hour_rate = timeEntires[lastIndex]?.hour_rate;
        if (hour_rate) obj.hour_rate = hour_rate;
      } catch (err) {}
    }
    if (props.selectedInvoice) obj.is_new = true;
    obj.is_added_entry = true;
    obj.added_new_time_entry = true;
    _timeEntries.push(obj);
    setTimeEntries([..._timeEntries]);
  };

  const pickExtractedDate = (dateArray) => {
    return {
      time_entry_from: dateArray?.[0]
        ? convertToTimezoneFormat(moment(dateArray[0]).startOf('day'), userContext?.userDetails.timezone)
        : '',
      time_entry_to: dateArray?.[0]
        ? convertToTimezoneFormat(moment(dateArray[1] ? dateArray[1] : dateArray[0]).endOf('day'), userContext?.userDetails.timezone)
        : '',
    };
  };

  const onChangeCalendar = async (e) => {
    setSelectedDate(e.value);
    let data = {
      case_id: selectedCase?.id,
      time_entry_date: '',
      ...pickExtractedDate(e.value),
      time_entry_status: 'OPEN',
      search_key: '',
      billing_status: billingStatusFilter, // Use the selected filter value
    };
    if (!props.selectedInvoice) {
      let response = await totalCountEvent('time_entries', selectedCase?.id);
      let limit = response?.data > 0 ? response?.data : 0;
      loadTimeEntries(data, limit);
    }
  };

  const addExpense = () => {
    let obj = {
      billable: true,
      case_id: '',
      case_name: '',
      expense_date: '',
      expense_status: '',
      expense_type: '',
      expense_type_id: '',
      quantity: '',
      rate_per_unit: '',
      team_member_id: '',
      team_member_name: '',
      total_amount: '',
      fee_type: 'fixed',
    };
    if (props.selectedInvoice) obj.is_new = true;
    obj.new_expense_added = true;
    expenses.push(obj);
    setExpenses([...expenses]);
  };

  const addAdjustment = () => {
    let obj = {
      item: adjustmentItems[0].value,
      applied_to: appliedToItems[0].value,
      type: adjustmentTypes[0].value,
      notes: '',
      basic_amount: '',
      percentage: '',
      amount: '',
    };
    if (props.selectedInvoice) obj.is_new = true;
    adjustments.push(obj);
    setAdjustments([...adjustments]);
  };

  const onChangeFlatFeeDate = (e, props) => {
    let index = props?.rowIndex;
    flatFees[index].flat_fee_date = e.value;
    flatFeeError[`${index}_date`] = '';
    setFlatFeeError({ ...flatFeeError });
    setFlatFees(flatFees);
  };

  const deleteFlatFee = (props) => {
    flatFees.splice(props.rowIndex, 1);
    setFlatFees([...flatFees]);
    isChanged.flat_fees = true;
    setIsChanged({ ...isChanged });
    setFlatFeeError({});
  };

  const deleteTimeEntry = (props) => {
    timeEntires.splice(props.rowIndex, 1);
    setTimeEntries([...timeEntires]);
    isChanged.time_entries = true;
    setIsChanged({ ...isChanged });
    setTimeEntriesError({});
    if (props?.rowData?.invoice_ref) {
      const timeEntryData = {
        ...props?.rowData,
        invoice_ref: '',
        time_entry_status: 'OPEN',
      };
      updateTimeEntry(timeEntryData, selectedCase?.is_lead ? selectedCase?.is_lead : false, '', true, false)
        .then((response) => {
          dispatch(nofifyTimeManager(response.data));
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.DELETE_TIME_ENTRY_SUCCESS);
        })
        .catch((err) => {
          addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.DELETE_TIME_ENTRY_FAILED);
        });
    }
  };

  const deleteExpense = (props) => {
    expenses.splice(props.rowIndex, 1);
    setExpenses([...expenses]);
    isChanged.expenses = true;
    setIsChanged({ ...isChanged });
    setExpenseError({});
    if (props?.rowData?.invoice_ref) {
      const expenseData = {
        ...props?.rowData,
        invoice_ref: '',
        expense_status: 'UNINVOICED',
      };
      updateExpense(expenseData, selectedCase?.is_lead ? selectedCase?.is_lead : false)
        .then((response) => {
          addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.EXPENSE_UPDATED_SUCCESS);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.EXPENSE_UPDATE_FAILED);
        });
    }
  };

  const deleteAdjustment = (props) => {
    adjustments.splice(props.rowIndex, 1);
    setAdjustments([...adjustments]);
    isChanged.adjustments = true;
    setIsChanged({ ...isChanged });
    setAdjustmentError({});
  };

  const generatePlan = () => {
    validatePaymentPlan(false);
    let totalAmountLocal = totalAmount;
    if (
      paymentPlan &&
      totalAmountLocal &&
      totalAmountLocal > 0 &&
      paymentStartDate &&
      selectedFrequency &&
      numberOfPayments &&
      numberOfPayments > 0 &&
      firstPaymentAmount >= 0
    ) {
      paymentPlanError['payment_plan'] = '';
      setPaymentPlanError({ ...paymentPlanError });
      let payment_dates = [];
      let number_of_payments = numberOfPayments ? parseInt(numberOfPayments) : 0;
      if (number_of_payments >= 1) {
        let amount = totalAmountLocal - firstPaymentAmount;
        if (firstPaymentAmount && firstPaymentAmount > 0) number_of_payments = number_of_payments - 1;

        let due_amount = amount / number_of_payments;
        due_amount = fixToTwoDecimal(due_amount);

        let first_payment = due_amount;

        let date = new Date(paymentStartDate);

        if (!firstPaymentAmount || firstPaymentAmount === 0) {
          payment_dates.push({ date: paymentStartDate, amount: first_payment });
          number_of_payments = number_of_payments - 1;
        } else if (firstPaymentAmount && firstPaymentAmount > 0) {
          payment_dates.push({
            date: paymentStartDate,
            amount: firstPaymentAmount,
          });
        }

        for (let i = 0; i < number_of_payments; i++) {
          payment_dates.push({
            date: date,
            amount: typeof due_amount === 'number' ? due_amount.toString() : due_amount,
          });
          date = nextDate(selectedFrequency, date);
        }

        // Calculate the sum of all payments so far and adjust the last payment to make up the difference
        if (payment_dates && payment_dates.length > 0) {
          let sumOfPayments = payment_dates.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);
          let diff = Math.round((totalAmountLocal - sumOfPayments) * 100) / 100; // Round to 2 decimal places
          if (Math.abs(diff) >= 0.01) {
            let lastPaymentAmount = parseFloat(payment_dates[payment_dates.length - 1].amount || 0);
            let adjustedAmount = Math.round((lastPaymentAmount + diff) * 100) / 100;
            payment_dates[payment_dates.length - 1].amount = adjustedAmount.toString();
          }
        }

        setPaymentDates([...payment_dates]);
      } else {
        setPaymentDates([]);
      }
      setPaymentPlanError({});
    } else {
      setPaymentDates([]);
    }
  };

  const sendInvoice = async (data) => {
    const { pk, sk } = data;
    const params = {
      contact_id: selectedBillingContact?.contact_id,
      invoice_pk: pk,
      invoice_sk: sk,
      is_lead: isLeadSpecific === true ? isLeadSpecific : selectedCase?.is_lead,
    };
    sendInvoiceReport(convertObjectToQuery(params))
      .then((response) => {
        addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.SEND_INVOICE_SUCCESS);
      })
      .catch((err) => {
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.SEND_INVOICE_FAILED);
      });
  };

  const accept = () => {
    dispatch(clearCaseDetailsAction());
    setPaymentPlanError({});
    setFlatFeeError({});
    setTimeEntriesError({});
    setExpenseError({});
    setAdjustmentError({});
    setInvoiceDetails();
    setUnPaidInvoices([]);
    props.onHide();
  };

  const reject = () => {};

  const confirm = () => {
    confirmDialog({
      message: 'Unsaved Data will be lost, Do you want to proceed?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept,
      reject,
      closable: false,
    });
  };

  const setHoursRate = () => {
    getUserHourRate().then((response) => {
      if (response?.data?.rate?.rate) {
        setUserHourRate(response?.data?.rate?.rate);
      }
    });
  };

  function getAllCaseList(is_lead = false, case_id = '', exclude_pi_case = true, keyword = '', limit = 15, is_filter_dropdown = true) {
    listCasesAndLeads(is_lead, case_id, exclude_pi_case, keyword, limit, is_filter_dropdown)
      .then((res) => {
        let tempArray = [];
        res?.data?.case_list?.forEach((item) => {
          tempArray.push({
            label:
              item && item.case_description && item.case_description.case_name
                ? `${item.unique_number ? `${item.unique_number} ` : ''}${item.case_description.case_name}`
                : 'TBD',
            value: item.case_description.case_name,
            id: item?.case_id,
            case_description: item.case_description,
          });
        });
        if (!props?.caseView && !props?.isLeadSpecific) {
          res?.data?.lead_list?.forEach((item) => {
            tempArray.push({
              label:
                item && item.case_description && item.case_description.case_name
                  ? `${item.unique_number ? `${item.unique_number} ` : ''}${item.case_description.case_name}`
                  : 'TBD',
              value: item.case_description.case_name,
              id: item?.case_id,
              is_lead: item?.is_lead,
              case_description: item.case_description,
            });
          });
        }
        setCaseList(tempArray);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const fetchData = useCallback((query) => {
    getAllCaseList(false, '', true, query, 15, true);
  }, []);

  const delayedSearch = useCallback(
    debounce((query) => {
      fetchData(query);
    }, 500),
    [fetchData]
  );

  const accountsListFiltered = useMemo(() => {
    let filteredAccounts = [...(accountList || [])];
    const _caseDetails = caseDetails || caseDetailsState?.caseDetails;
    if (_caseDetails?.default_trust_account?.[0]?.account_id) {
      filteredAccounts = filteredAccounts?.filter(
        (account) => account?.account_id === _caseDetails?.default_trust_account?.[0]?.account_id || account?.account_type === 'operating'
      );
    }
    if (_caseDetails?.default_operating_account?.[0]?.account_id) {
      filteredAccounts = filteredAccounts.filter(
        (account) => account?.account_id === _caseDetails?.default_operating_account?.[0]?.account_id || account?.account_type === 'trust'
      );
    }
    return filteredAccounts;
  }, [accountList, caseDetails, caseDetailsState?.caseDetails]);

  /** =========================================   All useEffects section starts  ====================================================== **/

  /**--------Total count api section starts -----------*/

  const loadActivityType = (practiceAreaId = null) => {
    totalCountEvent('activity_type')
      .then((response) => {
        const filters = {
          category: 'manual',
          status: 'active',
        };
        if (practiceAreaId) {
          filters.practice_area_ids = [practiceAreaId];
        }

        listActivityTypes('', response.data, '', 'forward', filters).then((response) => {
          let activity_types = [];
          if (response?.data?.activity_types?.length > 0) {
            activity_types = response?.data?.activity_types?.map((index) => {
              return {
                activity_type_code: index.activity_type_code,
                activity_type: index.activity_type,
                activity_type_id: index.activity_type_id,
              };
            });
          }
          setActivityTypes([...activity_types]);
        });
      })
      .catch((err) => {});
  };

  const createTimeEntries = async (rowData, onTimeEntrySuccess) => {
    try {
      setLoading(true);

      const hourRate = rowData?.hour_rate ? String(rowData?.hour_rate) : '0';
      const totalHours = rowData?.total_hours ? String(rowData?.total_hours) : '0';

      const timeEntryData = {
        ...rowData,
        hour_rate: hourRate,
        total_hours: totalHours,
        time_entry_status: rowData?.invoice_ref ? 'INVOICED' : 'OPEN',
        amount: String(fixToTwoDecimal(Number(hourRate) * Number(totalHours))),
        case_id: selectedCase?.case_id ? selectedCase?.case_id : selectedCase?.id,
        case_name: selectedCase?.case_description?.case_name ? selectedCase?.case_description?.case_name : selectedCase?.value,
      };

      const singleEntry = { ...timeEntryData };
      delete singleEntry.time_entry_status;
      const payload = { time_entry_status: timeEntryData?.time_entry_status || 'OPEN', time_entries: [singleEntry] };
      const response = await createTimeEntry(payload, selectedCase?.is_lead ? selectedCase?.is_lead : false);
      onTimeEntrySuccess?.();
      const createdEntry = response?.data;

      rowData.pk = createdEntry?.pk;
      rowData.sk = createdEntry?.sk;

      setTimeEntries((prevEntries) => {
        const isDuplicate = prevEntries.some((entry) => entry?.pk === createdEntry?.pk && entry?.sk === createdEntry?.sk);
        if (isDuplicate) return prevEntries;
        return [...prevEntries, createdEntry];
      });

      addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.CREATE_TIME_ENTRY_SUCCESS);
    } catch (err) {
      console.error(err);
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.CREATE_TIME_ENTRY_FAILED);
    } finally {
      setLoading(false);
    }
  };

  const updateTimeEntries = (rowData, onTimeEntrySuccess) => {
    if (rowData?.hour_rate) {
      rowData.hour_rate = String(rowData?.hour_rate);
    }
    if (rowData?.total_hours) {
      rowData.total_hours = String(rowData?.total_hours);
    }

    const timeEntryData = {
      ...rowData,
      case_id: selectedCase?.case_id ? selectedCase?.case_id : selectedCase?.id,
      case_name: selectedCase?.case_description?.case_name ? selectedCase?.case_description?.case_name : selectedCase?.value,
      amount: String(fixToTwoDecimal(Number(rowData?.hour_rate) * Number(rowData?.total_hours))),
      time_entry_status: rowData?.invoice_ref ? 'INVOICED' : 'OPEN',
    };

    updateTimeEntry(timeEntryData, selectedCase?.is_lead ? selectedCase?.is_lead : false, '', true, false)
      .then((response) => {
        onTimeEntrySuccess?.();
        dispatch(nofifyTimeManager(response.data));
        addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.UPDATE_TIME_ENTRY_SUCCESS);
      })
      .catch((err) => {
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.UPDATE_TIME_ENTRY_FAILED);
      });
  };

  const createExpenses = async (rowData, onExpenseSuccess) => {
    try {
      setLoading(true);

      const quantity = rowData?.quantity ? String(rowData?.quantity) : '0';
      const rate_per_unit = rowData?.rate_per_unit ? String(rowData?.rate_per_unit) : '0';

      const expenseData = {
        ...rowData,
        quantity: quantity,
        rate_per_unit: rate_per_unit,
        case_id: selectedCase?.case_id ? selectedCase?.case_id : selectedCase?.id,
        case_name: selectedCase?.case_description?.case_name ? selectedCase?.case_description?.case_name : selectedCase?.value,
        total_amount:
          rowData?.fee_type === 'hourly'
            ? String(fixToTwoDecimal(Number(quantity) * Number(rate_per_unit)))
            : String(rowData?.total_amount),
        expense_status: rowData?.invoice_ref ? 'INVOICED' : 'UNINVOICED',
      };

      const response = await createExpense(expenseData, selectedCase?.is_lead ? selectedCase?.is_lead : false);
      onExpenseSuccess?.();
      const createdExpense = response?.data;

      rowData.pk = createdExpense?.pk;
      rowData.sk = createdExpense?.sk;

      setExpenses((prevExpenses) => {
        const isDuplicate = prevExpenses.some((entry) => entry?.pk === createdExpense?.pk && entry?.sk === createdExpense?.sk);
        if (isDuplicate) return prevExpenses;
        return [...prevExpenses, createdExpense];
      });

      addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.EXPENSE_CREATE_SUCCESS);
    } catch (err) {
      console.error(err);
      addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.EXPENSE_CREATE_FAILED);
    } finally {
      setLoading(false);
    }
  };

  const updateExpenses = (rowData, onExpenseSuccess) => {
    if (rowData?.quantity) {
      rowData.quantity = String(rowData?.quantity);
    }
    if (rowData?.rate_per_unit) {
      rowData.rate_per_unit = String(rowData?.rate_per_unit);
    }
    const expenseData = {
      ...rowData,
      case_id: selectedCase?.case_id ? selectedCase?.case_id : selectedCase?.id,
      case_name: selectedCase?.case_description?.case_name ? selectedCase?.case_description?.case_name : selectedCase?.value,
      total_amount:
        rowData?.fee_type === 'fixed'
          ? String(rowData?.total_amount)
          : String(fixToTwoDecimal(Number(rowData?.quantity) * Number(rowData?.rate_per_unit))),
      expense_status: rowData?.invoice_ref ? 'INVOICED' : 'UNINVOICED',
    };
    updateExpense(expenseData, selectedCase?.is_lead ? selectedCase?.is_lead : false)
      .then((response) => {
        onExpenseSuccess?.();
        addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.EXPENSE_UPDATED_SUCCESS);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        addToast(false, toastConstant.toasterType.ERROR, toastConstant.api.FAILED, toastConstant.message.EXPENSE_UPDATE_FAILED);
      });
  };

  useEffect(() => {
    if (searchValue !== '') {
      delayedSearch(searchValue);
    } else if (searchValue === '' && load) {
      getAllCaseList(false, '', true, searchValue, 15, true);
    }
  }, [searchValue, delayedSearch, load]);

  useEffect(() => {
    totalCountEvent('expense_type').then((response) => {
      dispatch(listExpenseTypes('', response.data));
    });

    setHoursRate();
    dispatch(getOfficeLocation());
  }, []);

  /**--------Total count api section ends -----------*/

  useEffect(() => {
    if (selectedCase || invoiceDetails) {
      const practiceAreaId = selectedCase?.case_description?.case_practice_area || invoiceDetails?.case_description?.case_practice_area;

      if (practiceAreaId) {
        loadActivityType(practiceAreaId);
      } else {
        loadActivityType();
      }
    }
  }, [selectedCase?.id, invoiceDetails?.case_description?.case_practice_area]);

  useEffect(() => {
    if (caseDetailsState && caseDetailsState.caseDetails && !props.selectedInvoice && selectedCase && selectedCase?.id) {
      setTrustBalance();
      getTrustBalanceInfo(caseDetailsState?.caseDetails?.sk)
        .then((response) => {
          if (response?.data?.is_trust_balance && response?.data?.trust_balance) {
            setTrustBalance({ ...response?.data?.trust_balance });
            let debit_account_id = '';
            let debit_account_name = '';
            let amount_available = '';
            if (response?.data?.trust_balance?.trust_data && response?.data?.trust_balance?.trust_data.length > 0) {
              let trust_data = response?.data?.trust_balance?.trust_data;
              debit_account_id = trust_data[0]?.trust_account_id;
              debit_account_name = trust_data[0]?.trust_account_name;
              amount_available = trust_data[0]?.trust_balance;
            }
            setTrustAccountData({
              debit_account_id: debit_account_id,
              debit_account_name: debit_account_name,
              credit_account_name: '',
              credit_account_id: '',
              amount_available: amount_available,
              amount_paid: '',
              deposit_into: 'operating',
            });
          }
        })
        .catch((err) => {});
      setCaseDetails({ ...(props?.caseDetails || {} || caseDetailsState?.caseDetails || {}) });
      setTaxPercentage(caseDetailsState?.caseDetails?.billing_preferences?.tax_percentage ?? 0);
      getSubscriptionPlan(caseDetailsState?.caseDetails?.sk)
        .then((response) => {
          if (response?.data?.is_unpaid_invoice && response?.data?.unpaid_invoices) {
            setUnPaidInvoices(response?.data?.unpaid_invoices);
          } else {
            setUnPaidInvoices([]);
          }
          if (response?.data?.is_subscription && response?.data?.subscription) {
            if (response?.data?.subscription?.subscription_data?.amount_with_tax) {
              setSubscriptionTotal(parseFloat(response?.data?.subscription?.subscription_data?.amount_with_tax));
            } else {
              setSubscriptionTotal(parseFloat(response?.data?.subscription?.subscription_data?.rate));
            }
            setSubscriptionItems(response?.data?.subscription?.subscription_data);
            setDueDate(response?.data?.subscription?.subscription_data?.due_date || '');
            setInvoiceDate(new Date(response?.data?.subscription?.subscription_data?.invoice_date));
            setSelectedPaymentTerm('Monthly');
          }
          formErrors.subscription = '';
        })
        .catch((err) => {
          if (err?.response?.data) {
            formErrors.subscription = err?.response?.data;
            setFormErrors({ ...formErrors });
          }
        });
      getSettleMentDetails(caseDetailsState?.caseDetails?.case_id).then((response) => {
        if (!!response?.data?.total_settlement) {
          setSettlementDetails([response?.data]);
          setSettlementAmount(response?.data?.total_settlement ?? 0);
        }
      });
      // If 'due' key is present in billing_preferences, this is not the first invoice,
      // so we should not show default payment plan details
      if (!caseDetailsState?.caseDetails?.billing_preferences?.hasOwnProperty('due')) {
        // First invoice - set default payment plan details from billing_preferences
        setPaymentPlan(caseDetailsState?.caseDetails?.billing_preferences?.payment_plan);
        setNumberOfPayments(caseDetailsState?.caseDetails?.billing_preferences?.number_of_payments);
        setSelectedFrequency(caseDetailsState?.caseDetails?.billing_preferences?.frequency_of_payment);
        setRate(caseDetailsState?.caseDetails?.billing_preferences?.rate);
        setFirstPaymentAmount(parseFloat(caseDetailsState?.caseDetails?.billing_preferences?.payment_plan_details?.first_payment_amount));
        if (caseDetailsState?.caseDetails?.billing_preferences?.payment_plan_details?.payment_starting_date) {
          setPaymentStartDate(new Date(caseDetailsState?.caseDetails?.billing_preferences?.payment_plan_details?.payment_starting_date));
        }
        if (caseDetailsState?.caseDetails?.billing_preferences?.payment_plan_details?.payment_dates) {
          let payment_dates = caseDetailsState?.caseDetails?.billing_preferences?.payment_plan_details?.payment_dates;
          if (payment_dates && payment_dates.length > 0) {
            payment_dates.forEach((index) => {
              index.date = new Date(index.date);
            });
            setPaymentDates(payment_dates);
          }
        }
      }
      setDueDate();
      if (
        caseDetailsState.caseDetails?.billing_preferences?.payment_structure?.toLowerCase() === paymentStructure.FLAT_FEE?.toLowerCase()
      ) {
        let name = caseDetailsState.caseDetails?.created_by_details?.first_name;
        name = name + ' ' + caseDetailsState.caseDetails?.created_by_details?.last_name;
        let flat_fee_amount = '';
        let due = caseDetailsState?.caseDetails?.billing_preferences?.due;
        due = parseFloat(due);
        if (caseDetailsState?.caseDetails?.billing_preferences?.due) {
          flat_fee_amount = due;
        } else {
          if (!!caseDetailsState?.caseDetails?.billing_preferences?.amount_with_tax) {
            flat_fee_amount = caseDetailsState?.caseDetails?.billing_preferences?.amount_with_tax;
          } else {
            flat_fee_amount = caseDetailsState?.caseDetails?.billing_preferences?.rate;
          }
        }
        let obj = {
          flat_fee_date: new Date(),
          flat_fee_amount: flat_fee_amount,
          employee_name: name,
          employee_id: caseDetailsState.caseDetails?.created_by_details?.user_id,
          billable: true,
          item_name: paymentStructure.FLAT_FEE,
          tax_applied: true,
        };
        if (!!caseDetailsState?.caseDetails?.billing_preferences?.tax_percentage) {
          obj.actual_amount = reduceTax(flat_fee_amount, caseDetailsState?.caseDetails?.billing_preferences?.tax_percentage);
        }
        flatFees = [obj];
        setFlatFees([...flatFees]);
      }
      if (
        caseDetailsState.caseDetails?.billing_preferences?.payment_structure?.toLowerCase() === paymentStructure.SUBSCRIPTION?.toLowerCase()
      ) {
      }

      let clients = [];

      if (caseDetailsState?.caseDetails?.created_by_details && caseDetailsState?.caseDetails?.created_by_details.user_id) {
        let created_by_details = caseDetailsState?.caseDetails?.created_by_details;
        let name = created_by_details.first_name;
        if (created_by_details.last_name) name = name + ' ' + created_by_details.last_name;
        let obj = {
          contact_id: created_by_details.user_id,
          name: name,
        };
        clients.push(obj);
      }
      let team_members = [];
      if (caseDetailsState?.caseDetails?.team_member && caseDetailsState?.caseDetails?.team_member.length > 0) {
        caseDetailsState?.caseDetails?.team_member.forEach((index) => {
          let name = index.first_name;
          if (index.last_name) name = name + ' ' + index.last_name;
          let obj = {
            contact_id: index.contact_id,
            name: name,
          };
          if (clients.filter((index2) => index2.contact_id === index.contact_id).length === 0) {
            team_members.push(obj);
          }
        });
      }
      // Sort team members alphabetically
      const allMembers = [...team_members, ...clients];
      const sortedMembers = allMembers.sort((a, b) => {
        const nameA = a?.first_name || a?.title || a?.name || '';
        const nameB = b?.first_name || b?.title || b?.name || '';
        return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
      });
      setTeamMembers(sortedMembers);
    } else if (caseDetailsState && caseDetailsState.caseDetails) {
      setCaseDetails({ ...caseDetailsState.caseDetails });
      let clients = [];

      if (caseDetailsState?.caseDetails?.created_by_details && caseDetailsState?.caseDetails?.created_by_details.user_id) {
        let created_by_details = caseDetailsState?.caseDetails?.created_by_details;
        let name = created_by_details.first_name;
        if (created_by_details.last_name) name = name + ' ' + created_by_details.last_name;
        let obj = {
          contact_id: created_by_details.user_id,
          name: name,
        };
        clients.push(obj);
      }
      let team_members = [];
      if (caseDetailsState?.caseDetails?.team_member && caseDetailsState?.caseDetails?.team_member.length > 0) {
        caseDetailsState?.caseDetails?.team_member.forEach((index) => {
          let name = index.first_name;
          if (index.last_name) name = name + ' ' + index.last_name;
          let obj = {
            contact_id: index.contact_id,
            name: name,
          };
          if (clients.filter((index2) => index2.contact_id === index.contact_id).length === 0) {
            team_members.push(obj);
          }
        });
      }
      // Sort team members alphabetically
      const allMembers = [...team_members, ...clients];
      const sortedMembers = allMembers.sort((a, b) => {
        const nameA = a?.first_name || a?.title || a?.name || '';
        const nameB = b?.first_name || b?.title || b?.name || '';
        return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
      });
      setTeamMembers(sortedMembers);

      getSubscriptionPlan(caseDetailsState?.caseDetails?.sk)
        .then((response) => {
          const selectedInvoiceNumber = props?.selectedInvoice?.invoice_number;

          if (response?.data?.is_unpaid_invoice && Array?.isArray(response?.data?.unpaid_invoices)) {
            const selectedInvoiceSk = props?.selectedInvoice?.sk;

            // Find if the selected invoice exists in the response
            const responseInvoice = response?.data?.unpaid_invoices?.find((invoice) => invoice?.sk === selectedInvoiceSk);

            // If found, use the response invoice; otherwise, filter out the selected invoice
            const filteredInvoices = response?.data?.unpaid_invoices?.filter((invoice) => invoice?.sk !== selectedInvoiceSk);

            // Update state, ensuring uniqueness
            setUnPaidInvoices((prevInvoices) => {
              const updatedInvoices = responseInvoice
                ? [...prevInvoices, responseInvoice, ...filteredInvoices] // Keep response version
                : [...prevInvoices, ...filteredInvoices]; // Just filter

              // Remove duplicates based on sk and filter out selectedInvoice's invoice_number
              return Array?.from(new Map(updatedInvoices?.map((inv) => [inv?.sk, inv]))?.values())?.filter(
                (inv) => inv?.invoice_number !== selectedInvoiceNumber
              );
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    } else {
      setCaseDetails('');
    }
  }, [caseDetailsState]);

  useEffect(() => {
    if (props.show && !props.selectedInvoice) {
      setSelectedCase();
      setSelectedBillingContact();
      setInvoiceNumber();
      setDueDate();
      setSelectedPaymentTerm();
      setValue('reminder', []);
      setValue('is_client_contact', false);
      setValue('is_billing_contact', false);
      setSelectedStatus('Created');
      setExpenseTotal(0);
      setTotalHours(0);
      setTimeEntriesTotal(0);
      setTotalAmount(0);

      setSubTotalAmount(0);
      setTimeEntries([]);
      setExpenses([]);
      setFlatFees([]);
      setAdjustments([]);
      setFlatFeeTotal(0);
      setAdjustmentTotal(0);
      setDiscount(0);
      setPaymentDates([]);
      setPaymentPlan(false);
      setSelectedFrequency();
      setNumberOfPayments();
      setPaymentStartDate();
      setRate();
      setContingencyTotal(0);
      setContingencyItems();
      setSubscriptionTotal(0);
      setForwardedSubtotal(0);
      setUnPaidInvoices([]);
      setSelectedUnpaidInvoices([]);
      setTrustAccountData();
      setTrustBalance();
      setFormErrors({
        case: '',
        contact: '',
        invoice_id: '',
        invoice_date: '',
        due_date: '',
        payment_terms: '',
        status: '',
      });
      setContactDetails({});

      if (!props.selectedInvoice) {
        getInvoiceNumber()
          .then((response) => {
            if (response?.data?.invoice_number) {
              setInvoiceNumber(response?.data?.invoice_number);
            }
          })
          .catch((err) => {});
      }
    } else if (props.show) {
      setFormErrors({
        case: '',
        contact: '',
        invoice_id: '',
        invoice_date: '',
        due_date: '',
        payment_terms: '',
        status: '',
      });
      setUnPaidInvoices([]);
    }
  }, [props.show]);

  useEffect(() => {
    if (timeEntires && timeEntires.length > 0) {
      let subTotal = 0;
      let hours = 0;
      timeEntires.forEach((index) => {
        if (
          [paymentStructure.SUBSCRIPTION?.toLowerCase()].includes(
            caseDetailsState?.caseDetails?.billing_preferences?.payment_structure?.toLowerCase()
          )
        ) {
          index.billable = false;
        }
        if (index.billable) {
          let hour_rate = index?.hour_rate;
          let total_hours = index?.total_hours;
          hour_rate = hour_rate ? parseFloat(hour_rate) : 0;
          total_hours = total_hours ? parseFloat(total_hours) : 0;
          let total = hour_rate * total_hours;
          subTotal += total;
          hours += total_hours;
        }
      });
      setTimeEntriesTotal(fixToTwoDecimal(subTotal));
      setTotalHours(hours.toFixed(2));
    } else {
      setTimeEntriesTotal(0);
      setTotalHours(0);
    }
  }, [timeEntires, caseDetailsState]);

  useEffect(() => {
    if (expenses && expenses.length > 0) {
      let subTotal = 0;
      expenses.forEach((index) => {
        if (
          [paymentStructure.SUBSCRIPTION?.toLowerCase()].includes(
            caseDetailsState?.caseDetails?.billing_preferences?.payment_structure?.toLowerCase()
          ) ||
          (caseDetailsState?.caseDetails?.billing_preferences?.payment_structure?.toLowerCase() ===
            paymentStructure.CONTINGENCY_FEE?.toLowerCase() &&
            !caseDetailsState?.caseDetails?.billing_preferences?.is_expense)
        ) {
          index.billable = false;
        }
        if (index.billable) {
          let total_amount = index.total_amount;
          total_amount = total_amount ? parseFloat(total_amount) : 0;
          subTotal += total_amount;
          subTotal = +parseFloat(subTotal).toFixed(2);
        }
      });
      setExpenseTotal(subTotal);
    } else {
      setExpenseTotal(0);
    }
  }, [expenses, caseDetailsState]);

  useEffect(() => {
    if (flatFees && flatFees.length > 0) {
      let total = 0;
      let actualTotal = 0;
      flatFees.forEach((index) => {
        if (index.billable && index.flat_fee_amount) {
          let amount = parseFloat(index.flat_fee_amount);
          if (!!index?.actual_amount) {
            actualTotal += parseFloat(index.actual_amount);
          } else {
            actualTotal += amount;
          }
          total = total + amount;
          total = fixToTwoDecimal(total);
        }
      });
      setFlatFeeTotal(total);
      setFlatFeeActualTotal(actualTotal);
    } else {
      setFlatFeeTotal(0);
      setFlatFeeActualTotal(0);
    }
  }, [flatFees]);

  useEffect(() => {
    if (props.selectedInvoice && props.show) {
      setIsEdit(false);
      setInvoiceDetails();
      getInvoice(props.selectedInvoice.sk)
        .then((response) => {
          setInvoiceDetails({ ...response.data });
        })
        .catch((err) => {});
    } else {
      setIsEdit(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedInvoice, props.show]);

  useEffect(() => {
    if (invoiceDetails && isEdit) {
      //clearFields()
      setDepositInfo(invoiceDetails?.deposit_account_id);
      setInvoiceNumber(invoiceDetails.invoice_number);
      if (invoiceDetails?.invoice?.invoice_date) {
        setInvoiceDate(new Date(invoiceDetails?.invoice?.invoice_date));
      }
      if (invoiceDetails?.invoice?.due_date) {
        // Extract the calendar date from the due_date (which is stored as end of day)
        // and convert it to user's timezone to preserve the correct date
        const dueDateMoment = moment(invoiceDetails?.invoice?.due_date);
        if (userContext?.userDetails?.timezone) {
          // Convert to user's timezone and extract date components
          const dateInUserTimezone = dueDateMoment.tz(userContext?.userDetails?.timezone);
          const year = dateInUserTimezone.year();
          const month = dateInUserTimezone.month();
          const day = dateInUserTimezone.date();
          setDueDate(new Date(year, month, day));
        } else {
          // Fallback: extract date part and create Date object
          const dateOnly = dueDateMoment.format('YYYY-MM-DD');
          const [year, month, day] = dateOnly.split('-');
          setDueDate(new Date(year, month - 1, day));
        }
      }

      setSelectedStatus(invoiceDetails?.invoice?.invoice_status);
      setSelectedPaymentTerm(invoiceDetails?.invoice?.payment_terms || '');

      // Load time entry preferences if they exist
      if (invoiceDetails?.invoice?.time_entry_preferences) {
        // Set billing status filter
        if (invoiceDetails.invoice.time_entry_preferences.billing_status_filter !== undefined) {
          setBillingStatusFilter(invoiceDetails.invoice.time_entry_preferences.billing_status_filter);
        }

        // Set date range
        if (invoiceDetails.invoice.time_entry_preferences.date_range) {
          const dateRange = [];
          if (invoiceDetails.invoice.time_entry_preferences.date_range.from) {
            dateRange.push(new Date(invoiceDetails.invoice.time_entry_preferences.date_range.from));
          }
          if (invoiceDetails.invoice.time_entry_preferences.date_range.to) {
            dateRange.push(new Date(invoiceDetails.invoice.time_entry_preferences.date_range.to));
          }
          if (dateRange.length > 0) {
            setSelectedDate(dateRange);
          }
        }
      }

      onChangeCase({
        value: {
          id: invoiceDetails?.invoice?.case_id,
          label: invoiceDetails?.invoice?.case_name,
          ...invoiceDetails,
          ...props?.caseDetails,
        },
      });

      if (billingContacts && billingContacts.length > 0) {
        let contact_id = billingContacts.filter((index) => index?.contact_id === invoiceDetails?.invoice?.contact_id);
        if (contact_id.length > 0) setSelectedBillingContact(contact_id[0]);
      }
      setContactDetails({
        ...{
          city: invoiceDetails?.invoice?.city,
          street: invoiceDetails?.invoice?.street,
          state: invoiceDetails?.invoice?.state,
          country: invoiceDetails?.invoice?.country,
          zip: invoiceDetails?.invoice?.zip_code,
          phone: invoiceDetails?.invoice?.phone,
          country_code: invoiceDetails?.invoice?.country_code,
        },
      });

      setValue('reminder', parseReminderData(invoiceDetails?.invoice?.reminder) || []);
      setValue(
        'is_client_contact',
        invoiceDetails?.invoice?.invoice_assignee?.some((v) => v === 'main_client')
      );
      setValue(
        'is_billing_contact',
        invoiceDetails?.invoice?.invoice_assignee?.some((v) => v === 'billing_contact')
      );

      setTimeEntriesTotal(invoiceDetails?.time_entries?.total_amount ? parseFloat(invoiceDetails?.time_entries?.total_amount) : 0);
      setTotalHours(invoiceDetails?.time_entries?.total_amount ? parseFloat(invoiceDetails?.time_entries?.total_amount) : 0);
      setTimeEntries(invoiceDetails?.time_entries?.time_entry_data || []);
      setExpenseTotal(invoiceDetails?.expenses?.total_amount ? parseFloat(invoiceDetails?.expenses?.total_amount) : 0);
      setExpenses(invoiceDetails?.expenses?.expense_data);

      // Set tax percentage from invoice time entries or billing preferences if available
      if (invoiceDetails?.time_entries?.tax_percentage) {
        setTaxPercentage(parseFloat(invoiceDetails?.time_entries?.tax_percentage) || 0);
      } else if (invoiceDetails?.billing_preferences?.tax_percentage) {
        setTaxPercentage(parseFloat(invoiceDetails?.billing_preferences?.tax_percentage) || 0);
      }

      // Set rateWithTax directly from invoice if available (to preserve exact calculation)
      if (invoiceDetails?.time_entries?.total_amount_with_tax) {
        setRateWithTax(parseFloat(invoiceDetails?.time_entries?.total_amount_with_tax) || 0);
      }

      setAdjustments(invoiceDetails?.adjustments?.adjustment_data);
      setDiscount(invoiceDetails?.adjustments?.discount_amount ? parseFloat(invoiceDetails?.adjustments?.discount_amount) : 0);
      setAdjustmentTotal(invoiceDetails?.adjustments?.addition_amount);

      setFlatFees(() => {
        if (!!invoiceDetails?.flat_fees?.tax_percentage) {
          if (invoiceDetails?.flat_fees?.flat_fee_data.length > 0) {
            return invoiceDetails?.flat_fees?.flat_fee_data.map((data) => ({
              ...data,
              actual_amount: reduceTax(data.flat_fee_amount, invoiceDetails?.flat_fees?.tax_percentage),
            }));
          }
          return [];
        } else {
          return invoiceDetails?.flat_fees?.flat_fee_data;
        }
      });

      setPaymentPlan(invoiceDetails?.is_payment_plan);
      if (invoiceDetails?.is_payment_plan) {
        setPaymentStartDate(
          invoiceDetails?.payment_plan?.payment_starting_date ? new Date(invoiceDetails?.payment_plan?.payment_starting_date) : ''
        );
        setFirstPaymentAmount(
          invoiceDetails?.payment_plan?.first_payment_amount ? parseFloat(invoiceDetails?.payment_plan?.first_payment_amount) : 0
        );
        setPaymentDates(invoiceDetails?.payment_plan?.payment_plan_data);
        setSelectedFrequency(invoiceDetails?.payment_plan?.frequency_of_payment);
        setRate(invoiceDetails?.payment_plan?.total_amount);
        setNumberOfPayments(invoiceDetails?.payment_plan?.number_of_payments);
      }

      setSettlementAmount(invoiceDetails?.contingency?.settled_amount ? parseFloat(invoiceDetails?.contingency?.settled_amount) : 0);
      setContingencyTotal(invoiceDetails?.contingency?.total_amount ? parseFloat(invoiceDetails?.contingency?.total_amount) : 0);
      setContingencyItems(invoiceDetails?.contingency?.contingency_data);
      setLitigation(invoiceDetails?.contingency?.is_litigation);

      if (invoiceDetails?.subscription?.total_amount) {
        setTotalAmount(invoiceDetails?.subscription?.total_amount ? parseFloat(invoiceDetails?.subscription?.total_amount) : 0);
        setSubscriptionItems(invoiceDetails?.subscription?.subscription_data);
      } else if (invoiceDetails?.total_amount) {
        // Set total amount directly from invoice to avoid recalculation errors when loading
        // The useEffect will recalculate it if any dependencies change, but initial load should use stored value
        setTotalAmount(parseFloat(invoiceDetails?.total_amount) || 0);
      }

      // Set sub total if available
      if (invoiceDetails?.sub_total) {
        setSubTotalAmount(parseFloat(invoiceDetails?.sub_total) || 0);
      }

      if (invoiceDetails?.trust_account_data) {
        setTrustAccountData(invoiceDetails?.trust_account_data);
      }
      if (invoiceDetails?.unpaid_invoices?.unpaid_invoice_data) {
        setUnPaidInvoices(invoiceDetails?.unpaid_invoices?.unpaid_invoice_data);
        setSelectedUnpaidInvoices(invoiceDetails?.unpaid_invoices?.unpaid_invoice_data);
        setForwardedSubtotal(parseFloat(invoiceDetails?.unpaid_invoices?.total_amount));
        setForwardedTotalDueAmount(
          invoiceDetails?.unpaid_invoices?.unpaid_invoice_data
            .map((invoice) => parseFloat(invoice.due_amount)) // Map to an array of due amounts
            .reduce((total, amount) => total + amount, 0) // Reduce to get the sum of the due amounts
        );
      }
    }
    if (invoiceDetails?.payment_request_data) {
      setPaymentRequestData({
        ...invoiceDetails?.payment_request_data,
        depositInfo: invoiceDetails?.payment_request_data?.deposit_account_id,
        dueDate: invoiceDetails?.payment_request_data?.due_date || '',
      });
    }
    setTrustBalance(invoiceDetails?.invoice?.trust_balance_details);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceDetails, isEdit]);
  useEffect(() => {
    if (expense_types && expense_types.length > 0) {
      let types = expense_types.map((index) => {
        return {
          expense_type: index.expense_type,
          expense_type_id: index.expense_type_id,
        };
      });

      setExpenseTypes([...types]);
    }
  }, [expense_types]);

  useEffect(() => {
    if (adjustments && adjustments.length > 0) {
      let discount = 0;
      let total = 0;

      adjustments.forEach((index) => {
        let amount = 0;

        let basic_amount = index.basic_amount ? index.basic_amount : '';
        if (basic_amount) basic_amount = parseFloat(basic_amount);
        let percentage = index.percentage ? index.percentage : '';
        if (percentage) percentage = parseFloat(percentage);
        index.percentage = percentage;
        if (
          index.adjustment_type_id &&
          (index.adjustment_type_id === 1 || index?.adjustment_type_id === '1') &&
          basic_amount &&
          percentage
        ) {
          amount = basic_amount * (percentage / 100);
          amount = fixToTwoDecimal(amount);
          index.amount = amount;
        } else if (index.adjustment_type_id && (index.adjustment_type_id === 2 || index.adjustment_type_id === '2') && basic_amount) {
          amount = index.amount;
        }

        if (index.adjustment_item_id === 1 || index.adjustment_item_id === '1') {
          discount = discount + amount;
        } else {
          total = total + amount;
        }
      });

      setDiscount(fixToTwoDecimal(discount));
      setAdjustmentTotal(fixToTwoDecimal(total));
    } else {
      setDiscount(0);
      setAdjustmentTotal(0);
    }
  }, [adjustments]);

  useEffect(() => {
    let expense_total = expenseTotal ? fixToTwoDecimal(expenseTotal) : 0;
    let flat_fee_total = flatFeeTotal ? fixToTwoDecimal(flatFeeTotal) : 0;
    let rate_with_tax = rateWithTax ? +parseFloat(rateWithTax).toFixed(2) : 0;
    let adjustment_total = adjustmentTotal ? fixToTwoDecimal(adjustmentTotal) : 0;
    let discount_amount = discount ? fixToTwoDecimal(discount) : 0;

    const currentCaseDetailsForCalc =
      caseDetails && Object.keys(caseDetails).length > 0 && caseDetails.billing_preferences ? caseDetails : caseDetailsState?.caseDetails;

    const isRetainerCase =
      currentCaseDetailsForCalc?.billing_preferences?.payment_structure?.toLowerCase() ===
        paymentStructure.STANDARD_RETAINER?.toLowerCase() ||
      currentCaseDetailsForCalc?.billing_preferences?.payment_structure?.toLowerCase() ===
        paymentStructure.EVERGREEN_RETAINER?.toLowerCase();

    const isEditingInvoice = props.selectedInvoice && invoiceDetails;

    // Check if it's a lead - don't apply retainer amount logic for leads
    const isLead =
      currentCaseDetailsForCalc?.is_lead === true ||
      selectedCase?.is_lead === true ||
      isLeadSpecific === true ||
      props?.caseDetails?.is_lead === true;

    if (
      caseDetailsState.caseDetails?.billing_preferences?.payment_structure?.toLowerCase() ===
        paymentStructure.CONTINGENCY_FEE?.toLowerCase() &&
      currentCaseDetailsForCalc?.case_description?._case_practice_area_ === 'Personal Injury'
    ) {
      setTotalAmount((settlementAmount ?? 0) - (settlementDetails[0]?.attorney_fee_amount ?? 0) - (billsAndExpenseTotal ?? 0));
    } else {
      // For retainer cases (not leads), set total amount to only retainer amount
      if (isRetainerCase && !isEditingInvoice && !isLead) {
        const dueRaw = currentCaseDetailsForCalc?.billing_preferences?.due;
        const retainerAmount = parseFloat(currentCaseDetailsForCalc?.billing_preferences?.retainer_amount) || 0;

        // Only add retainer amount if due is undefined, null, or empty string (not if it's "0.00")
        const isDueUndefined = dueRaw === null || dueRaw === undefined || dueRaw === '';

        if (isDueUndefined) {
          if (retainerAmount > 0) {
            rate_with_tax = rate_with_tax + retainerAmount;
          }
        }
      }

      setSubTotalAmount(fixToTwoDecimal(expense_total + flat_fee_total + rate_with_tax + contingencyTotal + subscriptionTotal));
      setTotalAmount(
        fixToTwoDecimal(
          expense_total +
            flat_fee_total +
            rate_with_tax +
            adjustment_total +
            contingencyTotal +
            forwardedTotalDueAmount +
            subscriptionTotal -
            discount_amount
        )
      );
      setTotalDueAmount(fixToTwoDecimal(forwardedTotalDueAmount));
    }
  }, [
    expenseTotal,
    flatFeeTotal,
    timeEntriesTotal,
    rateWithTax,
    adjustmentTotal,
    discount,
    contingencyTotal,
    forwardedSubtotal,
    subscriptionTotal,
    billsAndExpenseTotal,
    settlementAmount,
    settlementDetails,
    forwardedTotalDueAmount,
    caseDetails?.billing_preferences?.retainer_amount,
    caseDetailsState?.caseDetails?.billing_preferences?.retainer_amount,
    caseDetails?.billing_preferences?.payment_structure,
    caseDetailsState?.caseDetails?.billing_preferences?.payment_structure,
    caseDetails?.billing_preferences?.due,
    caseDetailsState?.caseDetails?.billing_preferences?.due,
    caseDetails?.is_lead,
    caseDetailsState?.caseDetails?.is_lead,
    selectedCase?.is_lead,
    isLeadSpecific,
    props?.caseDetails?.is_lead,
    props?.selectedInvoice,
    invoiceDetails,
    taxPercentage,
  ]);

  useEffect(() => {
    if (caseDetails?.billing_preferences?.payment_structure?.toLowerCase() === paymentStructure.CONTINGENCY_FEE?.toLowerCase()) {
      let item = {
        type: 'Service',
        date: format(new Date(), 'MM/dd/yyyy'),
      };
      let balance = settlementAmount ?? 0;
      if (caseDetails?.billing_preferences?.is_expense) {
        balance = (settlementAmount ?? 0) - expenseTotal;
      }

      if (balance >= 0) {
        formErrors.settlement_amount = '';
        setFormErrors({ ...formErrors });
      } else {
        formErrors.settlement_amount = 'Settlement Amount should be greater than expense';
        setFormErrors({ ...formErrors });
      }

      if (litigation) {
        let litigationValue = fixToTwoDecimal(caseDetails?.billing_preferences?.litigation);
        item.notes = `Contingency Fee: ${caseDetails?.billing_preferences?.litigation} % of ${formatNumbersToCurrencyString(balance)}`;
        item.quantity = '1.00';
        if (balance > 0) {
          item.rate = fixToTwoDecimal((litigationValue / 100) * balance);
          item.total = fixToTwoDecimal((litigationValue / 100) * balance);
          setContingencyTotal(fixToTwoDecimal((litigationValue / 100) * balance));
        } else {
          item.rate = 0;
          item.total = 0;
          setContingencyTotal(0);
        }
      } else {
        let preLitigationValue = fixToTwoDecimal(caseDetails?.billing_preferences?.pre_litigation);
        item.notes = `Contingency Fee: ${caseDetails?.billing_preferences?.pre_litigation} % of ${formatNumbersToCurrencyString(balance)}`;
        item.quantity = '1.00';
        if (balance > 0) {
          item.rate = fixToTwoDecimal((preLitigationValue / 100) * balance);
          item.total = fixToTwoDecimal((preLitigationValue / 100) * balance);
          setContingencyTotal(fixToTwoDecimal((preLitigationValue / 100) * balance));
        } else {
          item.rate = 0;
          item.total = 0;
          setContingencyTotal(0);
        }
      }
      setContingencyItems([item]);
    } else {
      formErrors.settlement_amount = '';
      setFormErrors({ ...formErrors });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settlementAmount, litigation, expenseTotal, selectedCase, totalAmount]);

  useEffect(() => {
    let total = 0;
    let total_due_amount = 0;
    if (selectedUnpaidInvoices && selectedUnpaidInvoices.length > 0) {
      selectedUnpaidInvoices.forEach((index) => {
        let total_amount = parseFloat(index.invoice_amount);
        total = total + total_amount;
        let due_amount = parseFloat(index.due_amount);
        total_due_amount = total_due_amount + due_amount;
      });
    }
    setForwardedSubtotal(total);
    setForwardedTotalDueAmount(total_due_amount);
  }, [selectedUnpaidInvoices]);

  useEffect(() => {
    formErrors.total_amount = '';
    setFormErrors({ ...formErrors });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalAmount]);

  useEffect(() => {
    if (props.caseView && !props.selectedInvoice) {
      onChangeCase({
        value: { id: props?.caseDetails?.case_id, label: props?.caseDetails?.case_description?.case_name, ...props?.caseDetails },
      });
    }
  }, [props.caseView, props.selectedInvoice, props.show]);

  useEffect(() => {
    // Check payment structure from caseDetails or invoiceDetails
    const paymentStructureValue =
      caseDetails?.billing_preferences?.payment_structure ||
      invoiceDetails?.billing_preferences?.payment_structure ||
      invoiceDetails?.payment_structure;

    const isRetainerCase =
      paymentStructureValue?.toLowerCase() === paymentStructure.STANDARD_RETAINER?.toLowerCase() ||
      paymentStructureValue?.toLowerCase() === paymentStructure.EVERGREEN_RETAINER?.toLowerCase();

    // Only use stored invoice value on initial load when timeEntriesTotal matches invoice
    // If timeEntriesTotal has changed, user has made edits, so recalculate
    const invoiceTimeEntriesTotal = invoiceDetails?.time_entries?.total_amount
      ? parseFloat(invoiceDetails?.time_entries?.total_amount)
      : null;

    const isInitialLoad =
      props.selectedInvoice &&
      invoiceDetails &&
      invoiceTimeEntriesTotal !== null &&
      Math.abs(timeEntriesTotal - invoiceTimeEntriesTotal) < 0.01; // Account for floating point precision

    if (isInitialLoad && invoiceDetails?.time_entries?.total_amount_with_tax) {
      // On initial load, use the stored value from invoice
      setRateWithTax(parseFloat(invoiceDetails?.time_entries?.total_amount_with_tax) || 0);
      return; // Skip recalculation on initial load
    }

    // User has made changes or creating new invoice - recalculate
    if (isRetainerCase) {
      if (timeEntriesTotal > 0) {
        if (taxPercentage > 0) {
          let taxAmount = timeEntriesTotal * (parseFloat(taxPercentage) / 100);
          setRateWithTax(timeEntriesTotal + taxAmount);
        } else {
          setRateWithTax(timeEntriesTotal);
        }
      } else {
        setRateWithTax(0);
      }
    } else {
      setRateWithTax(timeEntriesTotal);
    }
  }, [taxPercentage, timeEntriesTotal, caseDetails?.billing_preferences?.payment_structure, props.selectedInvoice, invoiceDetails]);

  useEffect(() => {
    if (!!paymentPlan) {
      setDueDate();
    }
  }, [paymentPlan]);

  useEffect(() => {
    setBillsAndExpenseTotal(
      parseFloat(settlementDetails[0]?.total_bill ?? 0) +
        parseFloat(expenseTotal ?? 0) +
        parseFloat(settlementDetails[0]?.total_case_expense ?? 0)
    );
  }, [settlementDetails, expenseTotal]);

  useEffect(() => {
    if (invoiceDetails?.subscription?.total_amount && invoiceDetails?.subscription?.total_amount) {
      setSubscriptionTotal(invoiceDetails && invoiceDetails?.subscription?.total_amount);
    }
  }, [invoiceDetails]);

  // Load time entry preferences if they exist
  useEffect(() => {
    if (invoiceDetails?.invoice?.time_entry_preferences) {
      // Set billing status filter
      if (invoiceDetails.invoice.time_entry_preferences.billing_status_filter !== undefined) {
        setBillingStatusFilter(invoiceDetails.invoice.time_entry_preferences.billing_status_filter);
      }

      // Set date range
      if (invoiceDetails.invoice.time_entry_preferences.date_range) {
        const dateRange = [];
        if (invoiceDetails.invoice.time_entry_preferences.date_range.from) {
          dateRange.push(new Date(invoiceDetails.invoice.time_entry_preferences.date_range.from));
        }
        if (invoiceDetails.invoice.time_entry_preferences.date_range.to) {
          dateRange.push(new Date(invoiceDetails.invoice.time_entry_preferences.date_range.to));
        }
        if (dateRange.length > 0) {
          setSelectedDate(dateRange);
        }
      }

      // Load time entries with the saved preferences
      if (
        invoiceDetails?.invoice?.case_id &&
        (invoiceDetails.invoice.time_entry_preferences.billing_status_filter !== undefined ||
          invoiceDetails.invoice.time_entry_preferences.date_range)
      ) {
        const dateRange = invoiceDetails.invoice.time_entry_preferences.date_range;
        let extractedDates = {};

        if (dateRange && (dateRange.from || dateRange.to)) {
          const dateArray = [];
          if (dateRange.from) dateArray.push(new Date(dateRange.from));
          if (dateRange.to) dateArray.push(new Date(dateRange.to));
          extractedDates = pickExtractedDate(dateArray);
        }

        const data = {
          case_id: invoiceDetails.invoice.case_id,
          time_entry_date: '',
          ...extractedDates,
          time_entry_status: 'OPEN',
          search_key: '',
          billing_status: invoiceDetails.invoice.time_entry_preferences.billing_status_filter || '',
        };

        totalCountEvent('time_entries', invoiceDetails.invoice.case_id).then((response) => {
          const limit = response?.data > 0 ? response?.data : 0;
          loadTimeEntries(data, limit);
        });
      }
    }
  }, [invoiceDetails]);

  /** =========================================   All useEffects section ends  ====================================================== **/

  // Create a handler for the billing status filter change
  const onChangeBillingStatusFilter = (e) => {
    setBillingStatusFilter(e.value);

    if (selectedCase && selectedDate.length > 0) {
      let data = {
        case_id: selectedCase?.id,
        time_entry_date: '',
        ...pickExtractedDate(selectedDate),
        time_entry_status: 'OPEN',
        search_key: '',
        billing_status: e.value, // Use the newly selected value
      };

      if (!props.selectedInvoice) {
        totalCountEvent('time_entries', selectedCase?.id).then((response) => {
          let limit = response?.data > 0 ? response?.data : 0;
          loadTimeEntries(data, limit);
        });
      }
    }
  };

  return (
    <>
      <GlobalLoader />
      <Dialog
        maximized={true}
        visible={props.show}
        onHide={() => {
          if (!props.selectedInvoice) {
            confirm();
          } else {
            dispatch(clearCaseDetailsAction());
            setPaymentPlanError({});
            setFlatFeeError({});
            setTimeEntriesError({});
            setExpenseError({});
            setAdjustmentError({});
            setInvoiceDetails();
            setUnPaidInvoices([]);
            props.onHide();
          }
        }}
        header={props?.viewInvoice ? 'Invoice Details' : 'Create Invoice'}
        className="invoice-popup"
        id="main-div"
      >
        <div style={{ display: 'none' }}>
          <div id="invoicePrint">
            <InvoicePrintView invoiceDetails={invoiceDetails} />
          </div>
        </div>

        {(!props?.viewInvoice || isEdit) && (
          <div>
            <div className="row">
              {/* invoice for */}
              <InvoiceForForm
                isLeadSpecific={isLeadSpecific}
                caseDetails={caseDetails}
                caseView={caseView}
                selectedInvoice={selectedInvoice}
                caseList={caseList}
                selectedCase={selectedCase}
                billingContacts={billingContacts}
                selectedBillingContact={selectedBillingContact}
                contactDetails={contactDetails}
                onChangeCase={onChangeCase}
                onChangeContact={onChangeContact}
                setContactDetails={setContactDetails}
                formErrors={formErrors}
                setFormErrors={setFormErrors}
                searchValue={searchValue}
                setSearchValue={setSearchValue}
                showAddContactModal={showAddContactModal}
                setShowAddContactModal={setShowAddContactModal}
                setBillingContacts={setBillingContacts}
                showEnableLawftAccessModal={showEnableLawftAccessModal}
                setShowEnableLawftAccessModal={setShowEnableLawftAccessModal}
                enableLawftAccessBillingContact={enableLawftAccessBillingContact}
                caseDetailsState={caseDetailsState}
                showEmailRequiredDialogModal={showEmailRequiredDialogModal}
                setShowEmailRequiredDialogModal={setShowEmailRequiredDialogModal}
                onSubmit={onSubmit}
              />

              {/* invoice details */}
              <InvoiceDetailsForm
                isSubscription={isSubscription}
                isContigencyFee={isContigencyFee}
                isPersonalInjuryPracticeArea={isPersonalInjuryPracticeArea}
                invoiceNumber={invoiceNumber}
                invoiceDate={invoiceDate}
                paymentPlan={
                  paymentPlan &&
                  (isFlatFee ||
                    ((isStandardRetainer || isEverGreenRetainer) &&
                      currentCaseDetails?.is_lead !== true &&
                      selectedCase?.is_lead !== true &&
                      props?.caseDetails?.is_lead !== true &&
                      !isLeadSpecific))
                }
                selectedPaymentTerm={selectedPaymentTerm}
                dueDate={dueDate}
                control={control}
                watch={watch}
                setValue={setValue}
                selectedStatus={selectedStatus}
                checkDate={checkDate}
                checkNumber={checkNumber}
                setSelectedPaymentTerm={setSelectedPaymentTerm}
                setDueDate={setDueDate}
                setCheckDate={setCheckDate}
                setSelectedStatus={setSelectedStatus}
                setInvoiceDate={setInvoiceDate}
                setCheckNumber={setCheckNumber}
                formErrors={formErrors}
                setFormErrors={setFormErrors}
                isChanged={isChanged}
                setIsChanged={setIsChanged}
                viewInvoice={props?.viewInvoice}
                invoiceDetails={invoiceDetails}
                depositInfo={depositInfo}
                setDepositInfo={setDepositInfo}
                accountList={accountsListFiltered}
                trustBalance={trustBalance}
                timezone={userContext?.userDetails?.timezone}
              />
            </div>

            <div className="mt-4">
              <BillingDetails
                isFlatFee={isFlatFee}
                isSubscription={isSubscription}
                isContigencyFee={isContigencyFee}
                isEverGreenRetainer={isEverGreenRetainer}
                isStandardRetainer={isStandardRetainer}
                isPersonalInjuryPracticeArea={isPersonalInjuryPracticeArea}
                caseDetails={caseDetails}
                invoiceDetails={invoiceDetails}
                flatFees={flatFees}
                isChanged={isChanged}
                teamMembers={teamMembers}
                flatFeeActualTotal={flatFeeActualTotal}
                flatFeeTotal={flatFeeTotal}
                settlementAmount={settlementAmount}
                setSettlementAmount={setSettlementAmount}
                setFormErrors={setFormErrors}
                litigation={litigation}
                setLitigation={setLitigation}
                contingencyItems={contingencyItems}
                showTimeEntry={showTimeEntry}
                timeEntires={timeEntires}
                activityTypes={activityTypes}
                expenses={expenses}
                rateWithTax={rateWithTax}
                expenseTotal={expenseTotal}
                subTotalAmount={subTotalAmount}
                billsAndExpenseTotal={billsAndExpenseTotal}
                expenseTypes={expenseTypes}
                expenseError={expenseError}
                adjustmentError={adjustmentError}
                adjustments={adjustments}
                flatFeeError={flatFeeError}
                timeEntiresError={timeEntiresError}
                adjustmentTotal={adjustmentTotal}
                discount={discount}
                settlementDetails={settlementDetails}
                subscriptionItems={subscriptionItems}
                addExpense={addExpense}
                addFlatFee={addFlatFee}
                onChangeFlatFeeDate={onChangeFlatFeeDate}
                setIsChanged={setIsChanged}
                setFlatFees={setFlatFees}
                deleteFlatFee={deleteFlatFee}
                setShowTimeEntry={setShowTimeEntry}
                setTimeEntriesError={setTimeEntriesError}
                setTimeEntries={setTimeEntries}
                addTimeEntry={addTimeEntry}
                setExpenses={setExpenses}
                setExpenseError={setExpenseError}
                deleteExpense={deleteExpense}
                addAdjustment={addAdjustment}
                setAdjustments={setAdjustments}
                setAdjustmentError={setAdjustmentError}
                setFlatFeeError={setFlatFeeError}
                deleteTimeEntry={deleteTimeEntry}
                deleteAdjustment={deleteAdjustment}
                setCaseDetails={setCaseDetails}
                formErrors={formErrors}
                totalHours={totalHours}
                setTotalHours={setTotalHours}
                timeEntriesTotal={timeEntriesTotal}
                setTimeEntriesTotal={setTimeEntriesTotal}
                selectedCase={selectedCase}
                onChangeCalendar={onChangeCalendar}
                selectedDate={selectedDate}
                selectedInvoice={selectedInvoice}
                createTimeEntries={createTimeEntries}
                updateTimeEntries={updateTimeEntries}
                createExpenses={createExpenses}
                updateExpenses={updateExpenses}
                loading={loading}
                allTimeEntriesSaved={allTimeEntriesSaved}
                setAllTimeEntriesSaved={setAllTimeEntriesSaved}
                allExpensesSaved={allExpensesSaved}
                setAllExpensesSaved={setAllExpensesSaved}
                createTimeEntryInvoiceClicked={createTimeEntryInvoiceClicked}
                setCreateTimeEntryInvoiceClicked={setCreateTimeEntryInvoiceClicked}
                createExpenseInvoiceClicked={createExpenseInvoiceClicked}
                setCreateExpenseInvoiceClicked={setCreateExpenseInvoiceClicked}
                setExpenseTotal={setExpenseTotal}
                billingStatusFilter={billingStatusFilter}
                onChangeBillingStatusFilter={onChangeBillingStatusFilter}
              />

              {/* unpaid invoice */}
              {unPaidInvoices?.length > 0 && (
                <UnPaidInvoice
                  unPaidInvoices={unPaidInvoices}
                  selectedUnpaidInvoices={selectedUnpaidInvoices}
                  setSelectedUnpaidInvoices={setSelectedUnpaidInvoices}
                />
              )}
            </div>

            {/* invoice total component */}
            {(isFlatFee ||
              ((isStandardRetainer || isEverGreenRetainer) &&
                currentCaseDetails?.is_lead !== true &&
                selectedCase?.is_lead !== true &&
                props?.caseDetails?.is_lead !== true &&
                !isLeadSpecific)) && (
              <InvoiceTotal
                flatFeeTotal={flatFeeTotal}
                rateWithTax={rateWithTax}
                adjustmentTotal={adjustmentTotal}
                expenseTotal={expenseTotal}
                forwardedSubtotal={forwardedSubtotal}
                discount={discount}
                trustAccountData={trustAccountData}
                totalAmount={totalAmount}
                settlementAmount={settlementAmount}
                billsAndExpenseTotal={billsAndExpenseTotal}
                isContigencyFee={isContigencyFee}
                attorneyFeeAmount={attorneyFeeAmount}
                isPersonalInjuryPracticeArea={isPersonalInjuryPracticeArea}
                totalDueAmount={totalDueAmount}
                unPaidInvoices={unPaidInvoices}
              />
            )}

            {/* available trust fund component */}
            <AvailableTrustFund
              selectedInvoice={selectedInvoice}
              trustBalance={trustBalance}
              trustAccountData={trustAccountData}
              setTrustAccountData={setTrustAccountData}
              formErrors={formErrors}
              setFormErrors={setFormErrors}
              accountList={accountsListFiltered}
              totalAmount={totalAmount}
              depositInfo={depositInfo}
              setDepositInfo={setDepositInfo}
              setIsChanged={setIsChanged}
            />

            <PaymentRequest
              {...{
                showPR,
                setShowPR,
                accountList: accountsListFiltered,
                formErrors,
                setFormErrors,
                paymentRequestData,
                setPaymentRequestData,
                isEdit: props.selectedInvoice ? true : false,
              }}
            />
            {/* payment plan component  - only for flat fee */}
            {(isFlatFee ||
              ((isStandardRetainer || isEverGreenRetainer) &&
                currentCaseDetails?.is_lead !== true &&
                selectedCase?.is_lead !== true &&
                props?.caseDetails?.is_lead !== true &&
                !isLeadSpecific)) && (
              <PaymentPlan
                paymentPlan={paymentPlan}
                setPaymentPlan={setPaymentPlan}
                paymentDates={paymentDates}
                setPaymentDates={setPaymentDates}
                setPaymentPlanError={setPaymentPlanError}
                isChanged={isChanged}
                setIsChanged={setIsChanged}
                paymentPlanError={paymentPlanError}
                totalAmount={totalAmount}
                setRate={setRate}
                resetFormErrors={resetFormErrors}
                formErrors={formErrors}
                numberOfPayments={numberOfPayments}
                setNumberOfPayments={setNumberOfPayments}
                selectedFrequency={selectedFrequency}
                setSelectedFrequency={setSelectedFrequency}
                paymentStartDate={paymentStartDate}
                setPaymentStartDate={setPaymentStartDate}
                firstPaymentAmount={firstPaymentAmount}
                setFirstPaymentAmount={setFirstPaymentAmount}
                generatePlan={generatePlan}
              />
            )}

            {/* cancel ,create,create and send buttons */}
            <div className="mt-3 border-top">
              <div className="col-12 mt-3 d-flex justify-content-end">
                <Button className="p-button-secondary outline" label="Cancel" onClick={props?.onHide} />
                <Button
                  className="p-button-secondary ms-2"
                  label={props?.selectedInvoice ? 'Update' : 'Create'}
                  disabled={totalAmount === 0 || selectedBillingContact == undefined ? true : false}
                  onClick={() => {
                    onSubmit();
                  }}
                  loading={loading}
                />
                {!props?.selectedInvoice && (
                  <Button
                    className="p-button-secondary ms-2"
                    label={'Create and Send'}
                    disabled={totalAmount === 0 || selectedBillingContact == undefined ? true : false}
                    onClick={() => {
                      isContactHasEmail === false ? setShowEmailRequiredDialogModal(true) : onSubmit(true);
                    }}
                    loading={loading}
                  />
                )}
              </div>
            </div>
          </div>
        )}

        {props?.viewInvoice && !isEdit && (
          <ViewEditInvoice
            invoiceDetails={invoiceDetails}
            setIsEdit={setIsEdit}
            isLeadSpecific={props.isLeadSpecific}
            caseExpense={settlementDetails[0]?.case_expense_per_vendor}
            setShowAcceptPaymentModal={setShowRecordModal}
            loadInvoices={loadInvoices}
            filters={filters}
            getPageLimit={getPageLimit}
          />
        )}
      </Dialog>
    </>
  );
};

export default CreateInvoice;
